import { useEffect, useMemo } from "react";
import { useSoftUIController, setLanguage } from "context";

export const translations = {
  fr: {
    "nav.dashboard": "Tableau de bord",
    "nav.home": "Accueil",
    "nav.teachers": "Personnel",
    "nav.teacher_license": "Licences personnel",
    "nav.affectations": "Affectations",
    "nav.establishments": "Établissements",
    "nav.statistics": "Statistiques",
    "nav.users": "Gestion des utilisateurs",
    "nav.leave_requests": "Demandes de congé",
    "nav.recruiters": "Recruteurs",
    "nav.establishment_attendance": "Rapport présence",
    "nav.area_attendance": "Synthèse présence zone",
    "nav.notifications": "Notifications",
    "nav.settings": "Paramètres",
    "nav.assistant": "Assistant",
    "nav.change_password": "Changer le mot de passe",
    "nav.teacher_history": "Histoire du personnel",
    "nav.teacher_detail": "Fiche membre du personnel",
    "nav.sign_in": "Connexion",
    "nav.sign_up": "Créer un compte",

    "navbar.welcome": "Bienvenue",
    "navbar.change_password": "Changer le mot de passe",
    "navbar.logout": "Se déconnecter",
    "navbar.logout_title": "Déconnexion",
    "navbar.logout_success": "Vous avez été déconnecté avec succès.",
    "navbar.view_establishments": "Voir tous les établissements",
    "navbar.language": "Langue",

    "recruiters.title": "Recruteurs",
    "recruiters.add": "Ajouter un recruteur",
    "recruiters.none": "Aucun recruteur trouvé.",
    "recruiters.name": "Nom",
    "recruiters.phone": "Téléphone",
    "recruiters.whatsapp": "WhatsApp",
    "recruiters.username": "Nom d'utilisateur",
    "recruiters.actions": "Actions",
    "recruiters.edit": "Modifier un recruteur",
    "recruiters.add_modal": "Ajouter un recruteur",
    "recruiters.save": "Enregistrer",
    "recruiters.update": "Mettre à jour",
    "recruiters.cancel": "Annuler",
    "recruiters.teachers": "Personnel",
    "recruiters.teachers.none": "Aucun membre du personnel trouvé.",
    "recruiters.teachers.reg": "Matricule",
    "recruiters.teachers.first": "Prénoms",
    "recruiters.teachers.last": "Nom",
    "recruiters.teachers.gender": "Sexe",
    "recruiters.teachers.degree": "Diplôme",
    "recruiters.teachers.phone": "Téléphone",
    "recruiters.teachers.whatsapp": "WhatsApp",
    "recruiters.teachers.email": "Email",
    "recruiters.close": "Fermer",
    "recruiters.page_kicker": "RECRUTEMENT",
    "recruiters.page_hint": "Gérez les recruteurs, leurs coordonnées et le personnel associé.",
    "recruiters.stats.total": "Total recruteurs",
    "recruiters.stats.whatsapp": "Avec WhatsApp",
    "recruiters.stats.username": "Compte utilisateur",
    "recruiters.stats.with_phone": "Avec téléphone",
    "recruiters.stats.with_email": "Avec e-mail",
    "recruiters.table_title": "Annuaire des recruteurs",
    "recruiters.load_error": "Échec du chargement des recruteurs.",

    "teacher_license.title": "Licences personnel",
    "teacher_license.subtitle": "Activez les membres du personnel inscrits avant qu'ils puissent se connecter ou pointer. L'inscription est illimitée ; seuls les membres du personnel licenciés peuvent utiliser l'application.",
    "teacher_license.stats.total": "Total inscrits",
    "teacher_license.stats.licensed": "Licenciés",
    "teacher_license.stats.pending": "En attente d'activation",
    "teacher_license.stats.max_licensed": "Max licenciés",
    "teacher_license.stats.remaining": "Licences restantes",
    "teacher_license.filters": "Filtres",
    "teacher_license.province": "Province",
    "teacher_license.province_placeholder": "Sélectionner province",
    "teacher_license.department": "Département",
    "teacher_license.department_placeholder": "Sélectionner département",
    "teacher_license.subprefecture": "Sous-préfecture",
    "teacher_license.subprefecture_placeholder": "Sélectionner sous-préfecture",
    "teacher_license.establishment": "Établissement",
    "teacher_license.establishment_placeholder": "Sélectionner établissement",
    "teacher_license.status": "Statut",
    "teacher_license.status.all": "Tous",
    "teacher_license.status.licensed": "Licencié",
    "teacher_license.status.pending": "En attente d'activation",
    "teacher_license.matricule": "Matricule",
    "teacher_license.matricule_placeholder": "Rechercher sur la page courante…",
    "teacher_license.apply": "Appliquer",
    "teacher_license.reset": "Réinitialiser",
    "teacher_license.bulk.activate": "Activer (filtre)",
    "teacher_license.bulk.deactivate": "Désactiver (filtre)",
    "teacher_license.bulk.geo_required": "Sélectionnez au moins un filtre géographique pour les actions groupées.",
    "teacher_license.bulk.geo_note": "Les actions groupées n'affectent que le personnel avec une affectation active dans la zone sélectionnée.",
    "teacher_license.bulk.confirm_activate": "Activer les membres du personnel filtrés ?",
    "teacher_license.bulk.confirm_deactivate": "Désactiver les membres du personnel filtrés ?",
    "teacher_license.bulk.scope": "Périmètre :",
    "teacher_license.scope.all": "Tout le personnel (sans filtre géographique)",
    "teacher_license.col.reg": "Matricule",
    "teacher_license.col.name": "Nom",
    "teacher_license.col.phone": "Téléphone",
    "teacher_license.col.province": "Province",
    "teacher_license.col.department": "Département",
    "teacher_license.col.subprefecture": "Sous-préfecture",
    "teacher_license.col.establishment": "Établissement",
    "teacher_license.col.reg_date": "Date inscr.",
    "teacher_license.col.type": "Type",
    "teacher_license.col.status": "Statut",
    "teacher_license.col.actions": "Actions",
    "teacher_license.none": "Aucun membre du personnel trouvé.",
    "teacher_license.action.activate": "Activer",
    "teacher_license.action.deactivate": "Désactiver",
    "teacher_license.updated": "Mis à jour.",
    "teacher_license.error.load": "Impossible de charger le personnel.",
    "teacher_license.error.update": "Impossible de mettre à jour la licence.",
    "teacher_license.error.missing_db_id": "Impossible de déterminer l'id base de données du membre du personnel. Utilisez l'id numérique de la liste API, pas le matricule.",
    "teacher_license.not_applicable": "N/A",
    "teacher_license.staff_not_applicable": "Les licences s'appliquent aux enseignants et aux autres membres du personnel.",
    "teacher_license.cancel": "Annuler",
    "teacher_license.confirm": "Confirmer",
    "pagination.rows_per_page": "Lignes par page",

    "establishments.title": "Établissements",
    "establishments.page_kicker": "RÉPERTOIRE",
    "establishments.page_hint": "Consultez, créez et gérez les établissements.",
    "establishments.add": "Ajouter un établissement",
    "establishments.import_csv": "Importer CSV",
    "establishments.table_title": "Liste des établissements",
    "establishments.table_range": "{{start}}–{{end}} sur {{total}} établissements",
    "establishments.none": "Aucun établissement trouvé.",
    "establishments.load_error": "Échec du chargement des établissements.",
    "establishments.col.name": "Nom",
    "establishments.col.code": "Code",
    "establishments.col.type": "Type",
    "establishments.col.status": "Statut",
    "establishments.col.subprefecture": "Sous-préfecture",
    "establishments.col.coordinates": "Coordonnées",
    "establishments.actions": "Actions",
    "establishments.detail_title": "Détails de l'établissement",
    "establishments.add_modal": "Ajouter un établissement",
    "establishments.edit_modal": "Modifier l'établissement",
    "establishments.field.creation_date": "Date de création",
    "establishments.field.latitude": "Latitude",
    "establishments.field.longitude": "Longitude",
    "establishments.field.attendance_count": "Nombre de présences",
    "establishments.map_hint": "Cliquez sur la carte pour définir l'emplacement de l'établissement.",
    "establishments.save": "Enregistrer",
    "establishments.cancel": "Annuler",
    "establishments.close": "Fermer",
    "establishments.stats.total": "Total établissements",
    "establishments.stats.page": "Sur cette page",
    "establishments.create_success_title": "Enregistré",
    "establishments.create_success": "Établissement créé avec succès.",
    "establishments.create_error": "Échec de la création de l'établissement.",
    "establishments.update_success": "Établissement mis à jour avec succès.",
    "establishments.update_error": "Échec de la mise à jour de l'établissement.",
    "establishments.detail_error": "Échec du chargement des détails de l'établissement.",
    "establishments.delete_confirm_title": "Archiver l'établissement ?",
    "establishments.delete_confirm_text": "Cette action est irréversible.",
    "establishments.delete_warning_text": "Vous êtes sur le point d'archiver « {{name}} » (code : {{code}}). Impact : {{assignments}} affectations ({{active}} actives) et {{attendance}} enregistrements de présence.",
    "establishments.delete_continue": "Continuer",
    "establishments.delete_type_name_title": "Confirmer l'établissement",
    "establishments.delete_type_name_text": "Saisissez exactement le nom de l'établissement : « {{name}} »",
    "establishments.delete_verify": "Vérifier",
    "establishments.delete_name_mismatch": "Le nom de l'établissement ne correspond pas exactement.",
    "establishments.delete_reason_title": "Motif de l'archivage",
    "establishments.delete_reason_text": "Saisissez un motif clair. Il sera enregistré dans le journal d'audit de l'établissement.",
    "establishments.delete_reason_placeholder": "Motif",
    "establishments.delete_reason_required": "Un motif est obligatoire.",
    "establishments.delete_final_title": "Confirmation finale de l'archivage",
    "establishments.delete_final_text": "Saisissez « {{phrase}} » pour archiver cet établissement.",
    "establishments.delete_phrase_mismatch": "La phrase de confirmation ne correspond pas exactement.",
    "establishments.delete_confirm_yes": "Archiver l'établissement",
    "establishments.delete_success_title": "Archivé",
    "establishments.delete_success": "Établissement archivé avec succès.",
    "establishments.delete_error": "Échec de l'archivage de l'établissement.",
    "establishments.impact_error": "Impossible de vérifier l'impact de l'archivage.",
    "establishments.error_title": "Erreur",
    "establishments.search_placeholder": "Rechercher des établissements…",
    "establishments.search_results": "{{shown}} sur {{total}} établissements",
    "establishments.search_none": "Aucun établissement ne correspond à la recherche.",
    "establishments.loaded_count": "{{count}} établissement(s) chargé(s)",

    "recruiters.teachers_count": "{{n}} membre du personnel(s) lié(s)",
    "recruiters.form_hint_add": "Créez un recruteur avec identifiants de connexion.",
    "recruiters.form_hint_edit": "Mettez à jour les coordonnées de ce recruteur.",
    "recruiters.teachers_modal_kicker": "ÉQUIPE",
    "recruiters.teachers_modal_hint": "Liste du personnel rattaché à ce recruteur.",
    "recruiters.teachers_contact_hint": "{{phone}} avec téléphone · {{email}} avec e-mail · {{wa}} avec WhatsApp",

    "notifications.title": "Notifications push",
    "notifications.page_kicker": "COMMUNICATIONS",
    "notifications.page_hint": "Envoyez des notifications push au personnel, utilisateurs du panel ou recruteurs.",
    "notifications.tab.teachers": "Personnel",
    "notifications.tab.users": "Utilisateurs panel",
    "notifications.tab.recruiters": "Recruteurs",
    "notifications.field.title": "Titre",
    "notifications.field.title_placeholder": "Titre de la notification",
    "notifications.field.body": "Message",
    "notifications.field.body_placeholder": "Rédigez le message de la notification…",
    "notifications.audience": "Destinataires",
    "notifications.scope.all": "Tout le personnel",
    "notifications.scope.filtered": "Par localisation",
    "notifications.province": "Province",
    "notifications.province_placeholder": "Sélectionner province",
    "notifications.department": "Département",
    "notifications.department_placeholder": "Sélectionner département",
    "notifications.subprefecture": "Sous-préfecture",
    "notifications.subprefecture_placeholder": "Sélectionner sous-préfecture",
    "notifications.establishment": "Établissement",
    "notifications.establishment_placeholder": "Sélectionner établissement",
    "notifications.provinces": "Provinces",
    "notifications.provinces_placeholder": "Sélectionner une ou plusieurs provinces",
    "notifications.departments": "Départements",
    "notifications.departments_placeholder": "Sélectionner un ou plusieurs départements",
    "notifications.subprefectures": "Sous-préfectures",
    "notifications.subprefectures_placeholder": "Sélectionner une ou plusieurs sous-préfectures",
    "notifications.establishments": "Établissements",
    "notifications.establishments_placeholder": "Sélectionner un ou plusieurs établissements",
    "notifications.device_types": "Types d'appareils",
    "notifications.device.android": "Android",
    "notifications.device.ios": "iOS",
    "notifications.device_hint": "Envoi vers les plateformes sélectionnées uniquement (Android = 1, iOS = 2).",
    "notifications.filtered_hint": "Sélectionnez d'abord les provinces, puis affinez éventuellement par département, sous-préfecture ou établissement.",
    "notifications.selected_count": "{{n}} sélectionné(s)",
    "notifications.error.device_required": "Sélectionnez au moins un type d'appareil (Android ou iOS).",
    "notifications.error.filtered_required": "Sélectionnez au moins un filtre de localisation (province, département, sous-préfecture ou établissement).",
    "notifications.error.preview_teachers_unavailable": "L'estimation des destinataires n'est pas disponible pour le personnel. Vérifiez vos filtres puis envoyez.",
    "notifications.error.preview_unavailable": "L'estimation des destinataires n'est pas disponible. Vérifiez vos filtres puis envoyez.",
    "notifications.users_hint": "Envoyer aux utilisateurs du panel (admins) filtrés par province, département, sous-préfecture et/ou établissement.",
    "notifications.role": "Rôle",
    "notifications.role_placeholder": "Sélectionner un rôle",
    "notifications.recruiters_hint": "Cette notification sera envoyée à tous les recruteurs enregistrés disposant d'un jeton push valide.",
    "notifications.preview": "Estimer les destinataires",
    "notifications.previewing": "Estimation…",
    "notifications.send": "Envoyer la notification",
    "notifications.sending": "Envoi…",
    "notifications.cancel": "Annuler",
    "notifications.recipient_count": "{{count}} destinataire(s)",
    "notifications.send_confirm_title": "Envoyer la notification push ?",
    "notifications.send_confirm_text": "Ceci enverra « {{title}} » à {{audience}}. Continuer ?",
    "notifications.send_success_title": "Notification envoyée",
    "notifications.send_success_text": "Envoyée à {{count}} destinataire(s).",
    "notifications.history_title": "Notifications envoyées",
    "notifications.history.subtitle": "{{total}} job(s) au total",
    "notifications.history.date": "Date",
    "notifications.history.audience": "Audience",
    "notifications.history.notification": "Notification",
    "notifications.history.delivery": "Livraison",
    "notifications.history.recipients": "Destinataires",
    "notifications.history.status": "Statut",
    "notifications.history.requested": "Demandé",
    "notifications.history.started": "Démarré",
    "notifications.history.completed": "Terminé",
    "notifications.history.job_id": "Job ID",
    "notifications.history.filters": "Filtres",
    "notifications.history.details": "Détails",
    "notifications.history.failed_short": "échec",
    "notifications.history.summary_completed": "{{n}} terminé(s)",
    "notifications.history.summary_failed": "{{n}} échoué(s)",
    "notifications.history.summary_delivered": "{{n}} livré(s)",
    "notifications.history.empty": "Aucune notification envoyée pour le moment.",
    "notifications.error.title_required": "Le titre est requis.",
    "notifications.error.body_required": "Le message est requis.",
    "notifications.error.province_required": "Sélectionnez une province.",
    "notifications.error.department_required": "Sélectionnez la province et le département.",
    "notifications.error.subprefecture_required": "Sélectionnez province, département et sous-préfecture.",
    "notifications.error.establishment_required": "Sélectionnez la localisation jusqu'à l'établissement.",
    "notifications.error.user_filters_required": "Province, département et rôle sont requis.",
    "notifications.error.admin_filters_required": "Sélectionnez au moins un filtre de localisation pour les utilisateurs du panel.",
    "notifications.error.preview_failed": "Impossible d'estimer les destinataires. L'API notifications n'est peut-être pas disponible.",
    "notifications.error.send_failed": "Échec de l'envoi de la notification.",

    "settings.title": "Paramètres",
    "settings.page_kicker": "ADMINISTRATION",
    "settings.page_hint": "Gérez vos préférences et importez les établissements.",
    "settings.account.title": "Compte",
    "settings.account.name": "Nom",
    "settings.account.email": "E-mail",
    "settings.account.role": "Rôle",
    "settings.preferences.title": "Préférences",
    "settings.preferences.language_hint": "S'applique immédiatement dans tout le panel.",
    "settings.quick.title": "Raccourcis",
    "settings.quick.change_password_hint": "Modifier le mot de passe du compte.",
    "settings.quick.users_hint": "Gérer les utilisateurs du panel et les rôles.",
    "settings.quick.notifications_hint": "Envoyer des notifications push.",
    "settings.radius.title": "Rayon de présence",
    "settings.radius.subtitle": "Définissez la distance de pointage préférée pour l'application mobile.",
    "settings.radius.loading": "Chargement de la politique de présence…",
    "settings.radius.meters": "mètres",
    "settings.radius.preferred_distance": "Distance préférée",
    "settings.radius.validation": "Saisissez une valeur comprise entre 1 et 100 000 mètres.",
    "settings.radius.input_hint": "Plage autorisée : 1 à 100 000 mètres",
    "settings.radius.future_only": "Cette valeur s'applique aux futures présences. Les enregistrements existants conservent le rayon capturé lors de leur création.",
    "settings.radius.save": "Enregistrer le rayon",
    "settings.radius.saving": "Enregistrement…",
    "settings.radius.success": "Le rayon de présence a été mis à jour.",
    "settings.radius.error_load": "Impossible de charger le rayon de présence actuel.",
    "settings.radius.error_save": "Impossible de mettre à jour le rayon de présence. Veuillez réessayer.",
    "settings.radius.last_updated": "Dernière mise à jour",
    "settings.import.title": "Importer des établissements",
    "settings.import.subtitle": "Téléversez un fichier CSV via l'API web sécurisée.",
    "settings.import.hint": "Le CSV doit inclure province, département, sous-préfecture, nom, type, statut, coordonnées et code.",
    "settings.import.download_template": "Télécharger le modèle",
    "settings.import.drop_hint": "Glissez-déposez un fichier CSV ici",
    "settings.import.or_browse": "ou parcourez votre ordinateur",
    "settings.import.browse": "Parcourir CSV",
    "settings.import.clear": "Effacer",
    "settings.import.preview": "Aperçu",
    "settings.import.rows": "lignes",
    "settings.import.columns_title": "Colonnes CSV requises",
    "settings.import.column": "Colonne",
    "settings.import.example": "Exemple",
    "settings.import.upload": "Importer les établissements",
    "settings.import.uploading": "Importation…",
    "settings.import.cancel": "Annuler",
    "settings.import.confirm_title": "Importer les établissements ?",
    "settings.import.confirm_text": "Ceci enverra « {{file}} » au serveur.",
    "settings.import.success_title": "Import réussi",
    "settings.import.success_text": "Les établissements ont été importés avec succès.",
    "settings.import.success_redirect": "Les établissements ont été importés. Ouverture de la liste…",
    "settings.import.success_generic": "Import terminé.",
    "settings.import.error_title": "Échec de l'import",
    "settings.import.error_upload": "Échec de l'import. Vérifiez le format CSV et réessayez.",
    "settings.import.error_csv_only": "Veuillez sélectionner un fichier .csv.",
    "settings.import.error_no_file": "Sélectionnez d'abord un fichier CSV.",
    "settings.import.error_empty": "Le fichier CSV est vide.",
    "settings.import.error_read": "Impossible de lire le fichier CSV.",
    "settings.import.error_missing_columns": "Colonnes requises manquantes : {{cols}}",
    "settings.import.result_imported": "Importés",
    "settings.import.result_failed": "Échecs",

    "map.select_establishment": "Sélectionnez Établissement",
    "map.all_establishments": "Tous les établissements sur la carte",
    "map.no_teachers": "Aucun membre du personnel trouvé pour cette date.",
    "map.teachers_at_establishment": "Personnel",
    "map.click_for_teachers": "Cliquez pour charger le personnel.",
    "map.establishments_on_map": "{{count}} établissement(s) sur la carte",
    "map.focused_establishment": "1 établissement affiché",
    "map.loading_teachers": "Chargement du personnel…",
    "map.teachers_shown": "{{count}} pointage(s) membre du personnel",
    "map.click_establishment_hint": "Cliquez sur un établissement pour voir les liens personnel.",
    "map.view_profile": "Voir le profil",
    "map.view_more_teachers": "Voir {{count}} de plus",
    "map.show_less_teachers": "Voir moins",
    "map.select_establishment_placeholder": "Sélectionner établissement",
    "map.select_area_hint": "Sélectionnez province, département et sous-préfecture pour afficher les établissements.",
    "map.attendance_count": "Nombre de présences",
    "map.attendance_high": "Plus de présences",
    "map.attendance_low": "Moins de présences",
    "map.clear_selection": "Afficher tous les établissements",
    "map.filter.attend_date": "Date de pointage",
    "map.filter.radius": "Rayon (m)",
    "map.filter.view_mode": "Affichage",
    "map.filter.category": "Catégorie",
    "map.filter.category_all": "Toutes les catégories",
    "map.filter.radius_filter": "Filtre rayon",
    "map.filter.radius_all": "Tous",
    "map.filter.show_advanced": "Filtres",
    "map.filter.hide_advanced": "Moins",
    "map.filter.reset_advanced": "Réinitialiser",
    "map.filter.all_genders": "Tous les sexes",
    "map.filter.all_degrees": "Tous les diplômes",
    "map.filter.degree": "Diplôme",
    "map.filter.employment_status": "Statut",
    "map.filter.all_statuses": "Tous les statuts",
    "map.drawer.title": "Filtres carte",
    "map.drawer.subtitle": "Affinez l'affichage sans quitter la carte.",
    "map.drawer.close": "Fermer",
    "map.drawer.apply": "Terminé",
    "map.drawer.results_of": "sur {{total}} pointage(s) affiché(s)",
    "map.drawer.section_display": "Affichage carte",
    "map.drawer.section_display_hint": "Choisissez comment le personnel est représenté.",
    "map.drawer.section_distance": "Distance et présence",
    "map.drawer.section_distance_hint": "Définissez la distance maximale pour compter comme présent.",
    "map.drawer.section_teacher": "Profil membre du personnel",
    "map.drawer.section_teacher_hint": "Filtrez par type, statut, sexe, contrat ou diplôme.",
    "map.drawer.only_in_radius": "Uniquement dans le rayon",
    "map.drawer.only_out_radius": "Uniquement hors rayon",
    "map.drawer.legend": "Légende",
    "map.drawer.legend_in": "Vert — pointage dans le rayon autorisé",
    "map.drawer.legend_out": "Orange — pointage hors rayon",
    "map.drawer.view_hint.markers": "Un point par membre du personnel, coloré selon la distance.",
    "map.drawer.view_hint.cluster": "Regroupe les membres du personnel proches avec un compteur.",
    "map.drawer.view_hint.heatmap": "Zones colorées selon la densité de pointages.",
    "map.drawer.view_hint.lines": "Relie l'école au lieu de pointage de chaque membre du personnel.",
    "map.view.markers": "Marqueurs",
    "map.view.cluster": "Clusters",
    "map.view.heatmap": "Carte de chaleur",
    "map.view.lines": "Lignes",
    "map.kpi.in_radius": "Dans le rayon",
    "map.kpi.out_radius": "Hors rayon",
    "map.kpi.check_in_rate": "Taux de pointage",
    "map.view_history": "Voir l'historique",
    "map.popup.distance": "Distance",
    "map.popup.establishment": "Établissement",
    "map.area_view_active": "Vue zone — tous les établissements",
    "map.export": "Exporter les membres du personnel filtrés",
    "map.panel.show": "Synthèse régionale",
    "map.panel.hide": "Masquer le panneau",
    "map.panel.title": "Présence régionale",
    "map.panel.hint": "Comparez les membres du personnel affectés et pointés pour la zone et la période sélectionnées.",
    "map.panel.loading": "Chargement…",
    "map.panel.province": "Province",
    "map.panel.assigned": "Affectés",
    "map.panel.checked": "Pointés",
    "map.widget.kicker": "RÉPARTITION GÉO",
    "map.widget.title": "Carte personnel",
    "map.widget.hint": "Explorez les pointages sur la carte avec filtres géo, rayon, heatmap et export.",
    "map.widget.open": "Ouvrir la carte de répartition",
    "nav.teacher_map": "Carte personnel",
    "map.select_teacher": "Membre du personnel",
    "map.all_teachers_at_school": "Tout le personnel (école)",
    "map.clear_teacher": "Tout le personnel de l'école",
    "map.filter.start_date": "Du",
    "map.filter.end_date": "Au",
    "map.popup.date": "Date",
    "map.mode.teacher_timeline": "Chronologie membre du personnel",
    "map.mode.school_overview": "Vue établissement",
    "map.mode.area_overview": "Vue zone",
    "map.teachers_shown_day": "{{count}} le {{day}}",
    "map.drawer.view_context_teacher": "Les lignes relient les pointages du membre du personnel à l'établissement. La heatmap ne concerne que ce membre du personnel.",
    "map.drawer.view_context_school": "Les lignes relient l'établissement à chaque pointage membre du personnel. La heatmap agrège tout le personnel affichés.",
    "map.drawer.view_context_area": "Vue d'ensemble de tous les établissements de la sous-préfecture.",
    "map.timeline.days": "jours",
    "map.timeline.check_ins": "pointages",
    "map.timeline.all_days": "Tout",
    "map.timeline.prev": "Jour précédent",
    "map.timeline.next": "Jour suivant",

    "leave.title": "Demandes de congé",
    "leave.add": "Ajouter une demande",
    "leave.none": "Aucune demande trouvée.",
    "leave.teacher": "Nom du membre du personnel",
    "leave.type": "Type de congé",
    "leave.start": "Date de début",
    "leave.end": "Date de fin",
    "leave.reason": "Motif",
    "leave.status": "Statut",
    "leave.reviewed": "Date de validation",
    "leave.actions": "Actions",
    "leave.view": "Voir",
    "leave.update_status": "Mettre à jour",
    "leave.details": "Détails de la demande",
    "leave.status_title": "Mettre à jour le statut",
    "leave.status_hint": "Choisissez un statut pour cette demande.",
    "leave.cancel": "Annuler",
    "leave.save": "Enregistrer",
    "leave.saving": "Enregistrement...",
    "leave.add_title": "Ajouter une demande de congé",
    "leave.select_teacher": "Sélectionner un membre du personnel",
    "leave.select_type": "Sélectionner un type",
    "leave.reason_placeholder": "Ajoutez un motif court pour cette demande",
    "leave.page_kicker": "CONGÉS",
    "leave.page_hint": "Suivez les demandes et mettez à jour les statuts depuis cette vue.",
    "leave.stats.total": "Demandes",
    "leave.stats.pending": "En attente",
    "leave.stats.approved": "Approuvées",
    "leave.stats.rejected": "Rejetées",
    "leave.stats.cancelled": "Annulées",
    "leave.table_range": "{{start}}–{{end}} sur {{total}} demandes",
    "leave.table_title": "Toutes les demandes",
    "leave.modal_form_kicker": "NOUVELLE DEMANDE",
    "leave.modal_form_hint": "Renseignez les champs obligatoires. Les dates délimitent la période de congé.",
    "leave.detail_kicker": "DÉTAIL",
    "leave.detail_hint": "Synthèse de la demande et du motif.",

    "status.Pending": "En attente",
    "status.Approved": "Approuvée",
    "status.Rejected": "Rejetée",
    "status.Cancelled": "Annulée",
    "status.active": "Actif",
    "status.inactive": "Inactif",
    "gender.male": "Homme",
    "gender.female": "Femme",

    "teachers.title": "Ajouter un nouvel membre du personnel",
    "teachers.form_hint": "Créez ou mettez à jour une fiche membre du personnel.",
    "teachers.list": "Liste du personnel",
    "teachers.list_subtitle": "Vue d’ensemble du personnel membre du personnel et actions rapides.",
    "teachers.recruiter": "Recruteur",
    "teachers.recruiter_select": "Sélectionner un recruteur",
    "teachers.cancel": "Annuler",
    "teachers.save": "Enregistrer",
    "teachers.loading": "Chargement...",
    "teachers.name": "Nom",
    "teachers.firstname": "Prénom",
    "teachers.gender": "Sélectionnez le sexe",
    "teachers.gender_placeholder": "Sélectionner le sexe",
    "teachers.reg_date": "Date d'inscription",
    "teachers.degree": "Diplôme",
    "teachers.phone": "Téléphone",
    "teachers.dob": "Date de naissance",
    "teachers.status": "Sélectionnez le statut",
    "teachers.status_placeholder": "Sélectionner le statut",
    "teachers.certificate": "Certificat",
    "teachers.reg_number": "Numéro de registre",
    "teachers.identification": "Numéro d'identification",
    "teachers.integration_order": "Numéro de commande d'intégration",
    "teachers.table.reg": "Matricule du membre du personnel",
    "teachers.table.name": "Nom et prénoms du membre du personnel",
    "teachers.table.gender": "Sexe du membre du personnel",
    "teachers.table.status": "Statut du membre du personnel",
    "teachers.table.type": "Type",
    "teachers.filter.type": "Type",
    "teachers.type.all": "Tous",
    "teachers.type.teacher": "Membre du personnel",
    "teachers.type.staff": "Personnel",
    "teachers.person_type": "Type de personne",
    "teachers.table.license": "Licence",
    "teachers.license.licensed": "Licencié",
    "teachers.license.pending": "En attente d'activation",
    "teachers.register_success_title": "Membre du personnel inscrit",
    "teachers.register_success": "Membre du personnel inscrit avec succès. En attente d'activation de la licence.",
    "teachers.register_staff_success_title": "Personnel inscrit",
    "teachers.register_staff_success": "Membre du personnel inscrit avec succès. En attente d'activation de la licence.",
    "teachers.table.degree": "Diplôme du membre du personnel",
    "teachers.table.phone": "Téléphone",
    "teachers.table.whatsapp": "WhatsApp",
    "teachers.table.email": "Email",
    "teachers.table.action": "Action",
    "teachers.none": "Aucun membre du personnel à afficher.",
    "teachers.none_filtered": "Aucun membre du personnel ne correspond aux filtres.",
    "teachers.export_filtered": "Exporter la sélection",
    "teachers.export_error": "Échec de l'export",
    "teachers.export_error_hint": "Impossible de charger le personnel pour l'export.",
    "teachers.server_filters": "Recherche et filtres",
    "teachers.server_filters_hint": "Les filtres sont appliqués côté serveur. Les onglets utilisent stats.categoryCounts de l'API.",
    "teachers.search_placeholder": "Rechercher dans toutes les colonnes…",
    "teachers.filters_show": "Filtres avancés",
    "teachers.filters_hide": "Masquer filtres avancés",
    "teachers.status_filter_placeholder": "ex. Contractor",
    "teachers.recruiter_all": "Tous les recruteurs",
    "teachers.recruiter_name": "Nom du recruteur",
    "teachers.whatsapp": "WhatsApp",
    "teachers.email": "Email",
    "teachers.phone_placeholder": "Numéro de téléphone",
    "teachers.whatsapp_placeholder": "Numéro WhatsApp",
    "teachers.email_placeholder": "Adresse e-mail",
    "teachers.filters_minimize": "Réduire les filtres",
    "teachers.filters_expand": "Afficher les filtres",
    "teachers.filters_active_count": "{{count}} actif(s)",
    "teachers.filtered_count_server": "{{count}} résultat(s) (serveur)",
    "teachers.count_suffix": "membre du personnel(s)",
    "teachers.refresh": "Actualiser la liste",
    "teachers.edit_row": "Modifier",
    "teachers.stats.total": "Total",
    "teachers.stats.male": "Hommes",
    "teachers.stats.female": "Femmes",
    "teachers.stats.recruiter": "Avec recruteur",
    "teachers.stats.total_enrolled": "Total inscrits",
    "teachers.stats.category_results": "Résultats du filtre",
    "teachers.category.filter_label": "Filtrer par statut",
    "teachers.category.all": "Tout le personnel",
    "teachers.category.not_assigned": "Inscrits non affectés",
    "teachers.category.assigned": "Inscrits affectés",
    "teachers.category.assigned_with_attendance": "Affectés avec présence",
    "teachers.category.all_desc": "Tous les membres du personnel inscrits dans le système.",
    "teachers.category.not_assigned_desc": "Inscrits mais pas encore rattachés à un établissement.",
    "teachers.category.assigned_desc": "Rattachés à au moins un établissement.",
    "teachers.category.assigned_with_attendance_desc": "Affectés avec au moins une présence enregistrée.",
    "teachers.pipeline.kicker": "PARCOURS D'INSCRIPTION",
    "teachers.pipeline.hint": "Suivez le parcours de l'inscription à l'affectation et à la première présence. Cliquez sur une étape pour filtrer la liste.",
    "teachers.pipeline.enrolled_total": "{{count}} inscrits",
    "teachers.pipeline.share": "{{pct}}% des inscrits",
    "teachers.pipeline.viewing": "{{count}} membre du personnel(s) — {{label}}",
    "teachers.pipeline.active_filter": "Actif",
    "teachers.pipeline.legend_not_assigned": "Non affectés",
    "teachers.pipeline.legend_assigned_pending": "Affectés sans présence",
    "teachers.pipeline.legend_with_attendance": "Affectés avec présence",
    "teachers.table.allocated": "Affecté",
    "teachers.table.attendance": "Présence",
    "teachers.allocated.yes": "Oui",
    "teachers.allocated.no": "Non",
    "teachers.attendance.yes": "Oui",
    "teachers.attendance.no": "Non",
    "estab_attendance.page_kicker": "RAPPORT DE PRÉSENCE",
    "estab_attendance.title": "Rapport de présence par établissement",
    "estab_attendance.page_hint": "Sélectionnez les dates et le rayon pour consulter les présences. Filtrez par établissement si besoin — laissez vide pour tout le personnel.",
    "estab_attendance.province": "Province",
    "estab_attendance.department": "Département",
    "estab_attendance.subprefecture": "Sous-préfecture",
    "estab_attendance.establishment": "Établissement",
    "estab_attendance.select_province": "Sélectionner la province",
    "estab_attendance.select_department": "Sélectionner le département",
    "estab_attendance.select_subprefecture": "Sélectionner la sous-préfecture",
    "estab_attendance.select_establishment": "Sélectionner l'établissement",
    "estab_attendance.start_date": "Date de début",
    "estab_attendance.end_date": "Date de fin",
    "estab_attendance.radius": "Rayon (mètres)",
    "estab_attendance.radius_hint": "Distance maximale de l'établissement pour compter comme dans le rayon.",
    "estab_attendance.search": "Générer le rapport",
    "estab_attendance.error.establishment": "Veuillez sélectionner un établissement.",
    "estab_attendance.error.dates": "Veuillez sélectionner les dates de début et de fin.",
    "estab_attendance.error.date_order": "La date de début doit être antérieure à la date de fin.",
    "estab_attendance.error.radius": "Veuillez saisir un rayon valide en mètres.",
    "estab_attendance.error.load": "Échec du chargement du rapport de présence.",
    "estab_attendance.no_teachers": "Aucun membre du personnel trouvé pour cet établissement sur la période sélectionnée.",
    "estab_attendance.no_calendar": "Aucun jour de présence sur cette période.",
    "estab_attendance.calendar_title": "Calendrier de présence",
    "estab_attendance.expand_hint": "Cliquez sur une ligne membre du personnel pour afficher le calendrier jour par jour.",
    "estab_attendance.stats.workdays": "Jours ouvrés (hors dim.)",
    "estab_attendance.stats.teachers": "Personnel",
    "estab_attendance.stats.present_total": "Total jours présents",
    "estab_attendance.stats.in_radius_total": "Jours dans le rayon",
    "estab_attendance.stats.radius_label": "Rayon {{m}} m",
    "estab_attendance.col.teacher": "Membre du personnel",
    "estab_attendance.col.workdays": "Jours ouvrés",
    "estab_attendance.col.present": "Signalés",
    "estab_attendance.col.in_radius": "Dans le rayon",
    "estab_attendance.col.establishment": "Établissement",
    "estab_attendance.col.department": "Département",
    "estab_attendance.col.province": "Province",
    "estab_attendance.legend.in_radius": "Présent (dans le rayon)",
    "estab_attendance.legend.out_radius": "Présent (hors rayon)",
    "estab_attendance.legend.absent": "Absent",
    "estab_attendance.legend.sunday": "Dimanche (exclu)",
    "estab_attendance.tooltip.in_radius": "{{date}} — Présent dans le rayon",
    "estab_attendance.tooltip.out_radius": "{{date}} — Présent hors rayon",
    "estab_attendance.tooltip.absent": "{{date}} — Absent",
    "estab_attendance.tooltip.sunday": "{{date}} — Dimanche",
    "estab_attendance.tooltip.present": "{{date}} — Présent",
    "estab_attendance.matrix_title": "Calendrier de présence — tout le personnel",
    "estab_attendance.matrix_hint": "Une ligne par membre du personnel. Coche verte = présent dans le rayon ; coche orange = présent hors rayon.",
    "estab_attendance.matrix.col_name": "Nom et prenom",
    "estab_attendance.matrix_legend_in": "Présent dans le rayon",
    "estab_attendance.matrix_legend_out": "Présent hors rayon",
    "estab_attendance.matrix_legend_empty": "Vide = absent ou dimanche",
    "estab_attendance.all_establishments": "Tous les établissements (optionnel)",
    "estab_attendance.all_establishments_short": "Tous les établissements",
    "estab_attendance.establishment_optional_hint": "Laisser vide pour inclure tout le personnel sur la période et le rayon.",
    "estab_attendance.export_pdf": "Exporter PDF",
    "estab_attendance.export_excel": "Exporter Excel",
    "estab_attendance.export.error": "Échec de l'export.",
    "estab_attendance.export.summary": "Synthèse",
    "estab_attendance.export.daily": "Quotidien",
    "estab_attendance.export.matrix": "Matrice",
    "estab_attendance.export.date": "Date",
    "estab_attendance.export.status": "Statut",

    "area_attendance.page_kicker": "PRÉSENCE RÉGIONALE",
    "area_attendance.title": "Synthèse de présence par zone",
    "area_attendance.page_hint": "Comparez les membres du personnel affectés à ceux ayant pointé au moins le nombre minimum de jours, par province et département.",
    "area_attendance.start_date": "Date de début",
    "area_attendance.end_date": "Date de fin",
    "area_attendance.days_present": "Jours présents min.",
    "area_attendance.days_hint": "Un membre du personnel doit avoir pointé au moins ce nombre de jours pour être compté comme vérifié.",
    "area_attendance.search": "Charger la synthèse",
    "area_attendance.error.dates": "Veuillez sélectionner les dates de début et de fin.",
    "area_attendance.error.date_order": "La date de début doit être antérieure à la date de fin.",
    "area_attendance.error.days": "Veuillez saisir un nombre de jours valide (1 ou plus).",
    "area_attendance.error.load": "Échec du chargement de la synthèse de présence.",
    "area_attendance.no_results": "Aucune donnée pour les critères sélectionnés.",
    "area_attendance.query_hint": "{{start}} → {{end}} · min. {{days}} jour(s) de présence",
    "area_attendance.stats.provinces": "Provinces",
    "area_attendance.stats.departments": "Départements",
    "area_attendance.stats.assigned": "Personnel affecté",
    "area_attendance.stats.checked": "Personnel vérifié",
    "area_attendance.province_departments": "{{n}} département(s)",
    "area_attendance.chip.assigned": "{{n}} affectés",
    "area_attendance.chip.checked": "{{n}} vérifiés",
    "area_attendance.col.province": "Province",
    "area_attendance.col.department": "Département",
    "area_attendance.col.assigned": "Affectés",
    "area_attendance.col.checked": "Vérifiés",
    "area_attendance.col.rate": "Taux de pointage",
    "area_attendance.row.province_total": "Total province",
    "area_attendance.row.grand_total": "Total général",
    "area_attendance.all_rows_title": "Liste complète — toutes provinces et départements",

    "teachers.table_range": "{{start}}–{{end}} sur {{total}} personnel",
    "home.title": "Liste du personnel",
    "home.select_date": "Sélectionnez la date",
    "home.date_placeholder": "Sélectionnez une date",
    "home.search": "Recherche",
    "home.table.attend_date": "Date de pointage",
    "home.table.reg_number": "Matricule du membre du personnel",
    "home.table.teacher_name": "Nom et prénoms du membre du personnel",
    "home.table.gender": "Sexe du membre du personnel",
    "home.table.status": "Statut du membre du personnel",
    "home.table.degree": "Diplôme du membre du personnel",
    "home.table.est_coords": "Coordonnées de l'établissement",
    "home.table.att_coords": "Coordonnées du pointage",
    "home.table.distance": "Distance",
    "home.table.imei": "IMEI du téléphone",
    "home.modal.title": "Histoire",
    "home.modal.cancel": "Annuler",
    "home.modal.attend_date": "Date de pointage",
    "home.modal.est_coords": "Coordonnées de l'établissement",
    "home.modal.att_coords": "Coordonnées du pointage",
    "home.modal.distance": "Distance",
    "home.modal.imei": "IMEI du téléphone",
    "home.page_kicker": "PRÉSENCES",
    "home.page_hint": "Consultez les pointages par date et ouvrez l'historique d'un membre du personnel.",
    "home.stats.records": "Pointages",
    "home.stats.teachers": "Personnel",
    "home.stats.avg_distance": "Distance moy.",
    "home.stats.within_1km": "≤ 1 km",
    "home.stats.this_month": "Ce mois",
    "home.stats.this_week": "Cette semaine",
    "pagination.page_size": "Lignes par page",
    "home.table.section_title": "Pointages",
    "home.table_range": "{{start}}–{{end}} sur {{total}} lignes",
    "home.table_empty": "Aucun pointage à afficher.",
    "home.modal.subtitle": "Historique des pointages",
    "home.modal.kicker": "PERSONNEL",
    "home.modal.hint": "Heures de pointage, distance GPS par rapport à l'établissement et IMEI.",
    "home.modal.stats.records": "Entrées",
    "home.modal.stats.avg_distance": "Distance moy.",
    "home.modal.stats.span": "Première → dernière",
    "home.modal.stats.far": "> 1 km",
    "home.modal.empty": "Aucun historique pour ce membre du personnel.",
    "home.modal.close": "Fermer",
    "home.date_filter_hint": "Date sélectionnée : {{date}}",
    "home.date_filter_all": "Toutes les dates (chargement initial)",
    "dashboard.stats.teachers": "Personnel",
    "dashboard.stats.recruiters_total": "Recruteurs",
    "dashboard.stats.leave_pending": "Congés en attente",
    "dashboard.stats.users": "Utilisatrices",
    "dashboard.stats.missions_today": "Licences restantes",
    "dashboard.stats.assignments_total": "Nombre total d'affectations",
    "dashboard.chart.teachers": "Statistiques des Personnel",
    "dashboard.chart.establishments": "Statistiques des Établissements",
    "dashboard.chart.teacher_ratio": "Ratio Personnel (Jour / Cumulatif)",
    "dashboard.chart.establishment_ratio": "Ratio Établissements (Jour / Cumulatif)",
    "dashboard.filters.trend_title": "Période des tendances",
    "dashboard.filters.start_date": "Du",
    "dashboard.filters.end_date": "Au",
    "dashboard.filters.regional_title": "Vue régionale (date + rayon)",
    "dashboard.filters.snapshot_date": "Date du bilan",
    "dashboard.filters.radius_km": "Rayon (km)",
    "dashboard.filters.apply": "Mettre à jour",
    "dashboard.filters.refresh_all": "Tout actualiser",
    "dashboard.filters.update_trends": "Tendances",
    "dashboard.filters.update_regional": "Région",
    "dashboard.filters.radius_hint": "Saisie en km — converti en mètres pour l’API.",
    "dashboard.filters.panel_title": "Filtres de rapport",
    "dashboard.filters.panel_hint": "Choisissez la période pour les tendances et une date avec rayon pour les cartes régionales.",
    "dashboard.filters.panel_hint_short": "Les dates de tendance alimentent les graphiques du haut ; la date régionale et le rayon alimentent la carte, les deux graphiques régionaux et les deux KPI de présence.",
    "dashboard.filters.tooltip_trends": "Recharge Dashboard/stats pour la plage Du–Au : met à jour les deux premiers KPI, le graphique d’activité quotidienne et le taux de participation.",
    "dashboard.filters.tooltip_regional": "Recharge reports/statistical pour la date et le rayon : met à jour la carte, les deux graphiques régionaux et les KPI de pointage / dans le rayon.",
    "dashboard.filters.tooltip_refresh_all": "Enchaîne les appels (tendances, régions, recruteurs, congés) pour aligner indicateurs et aperçus.",
    "dashboard.filters.radius_m": "Distance (mètres)",
    "dashboard.filters.radius_hint_m": "Rayon en mètres, envoyé tel quel à l’API.",
    "dashboard.chart.daily_activity": "Activité quotidienne (pointages)",
    "dashboard.chart.daily_activity_hint": "Nombre de membres du personnel et d’établissements ayant reporté chaque jour.",
    "dashboard.chart.attendance_percentage": "Pourcentage de pointage",
    "dashboard.chart.attendance_percentage_hint": "Pourcentage quotidien des personnes ayant fait le pointage et de celles ne l’ayant pas fait.",
    "dashboard.chart.checked_in_pct": "Pointage effectué (%)",
    "dashboard.chart.not_checked_in_pct": "Pointage non effectué (%)",
    "dashboard.chart.participation_pct": "Taux de participation (% du référentiel)",
    "dashboard.chart.participation_teachers_title": "Participation personnel (% du référentiel)",
    "dashboard.chart.participation_teachers_hint": "Pointages quotidiens du personnel par rapport au référentiel.",
    "dashboard.chart.participation_establishment_title": "Participation établissements (% du référentiel)",
    "dashboard.chart.participation_establishment_hint": "Pointages quotidiens des établissements par rapport au référentiel.",
    "dashboard.chart.teachers_daily": "Personnel (jour)",
    "dashboard.chart.establishments_daily": "Établissements (jour)",
    "dashboard.chart.reported": "Déclarés",
    "dashboard.chart.within_radius": "Dans le rayon",
    "dashboard.regional.provinces": "Par province",
    "dashboard.regional.departments": "Par département",
    "dashboard.regional.establishments": "Par établissement",
    "dashboard.stats.reported_establishments": "Signalés (établissements)",
    "dashboard.stats.within_radius_total": "Dans le rayon (total)",
    "dashboard.stats.teachers_active": "Licenciés",
    "dashboard.stats.licensed_teachers": "Licenciés",
    "dashboard.stats.remaining_licenses": "Licences restantes",
    "dashboard.stats.registered_teachers": "Personnel inscrit",
    "dashboard.stats.max_licensed_teachers": "Max personnel licencié",
    "dashboard.stats.people_checked_in": "Personnes ayant fait le pointage",
    "dashboard.stats.licensed_capacity": "Capacité sous licence",
    "dashboard.stats.licensed_capacity_total": "Max personnel licencié",
    "dashboard.stats.slots_remaining": "Licences restantes",
    "dashboard.filters.apply_trends": "Appliquer la plage",
    "dashboard.filters.trend_range_hint": "Les graphiques quotidiens utilisent cette plage après Appliquer.",
    "dashboard.filters.apply_regional": "Appliquer la vue",
    "dashboard.filters.radius_quick_label": "Rayon rapide",
    "dashboard.filters.radius_preset_500m": "500 m",
    "dashboard.filters.radius_preset_5km": "5 km",
    "dashboard.filters.radius_preset_50km": "50 km",
    "dashboard.filters.radius_preset_500km": "500 km",
    "dashboard.chart.quota_title": "Licences personnel",
    "dashboard.chart.quota_summary_line": "Licenciés : {{licensed}} / {{max}} · Licences restantes : {{remaining}} · Inscrits : {{registered}}",
    "dashboard.chart.quota_insight_title": "Synthèse chiffrée",
    "dashboard.chart.quota_insight_subtitle": "Taux d'utilisation des licences en ce moment.",
    "dashboard.chart.license_fill_label": "Utilisation des licences",
    "dashboard.chart.quota_licensed": "Licenciés",
    "dashboard.chart.quota_remaining": "Licences restantes",
    "dashboard.chart.period_toolbar_title": "Fenêtre temporelle des graphiques",
    "dashboard.chart.period_toolbar_hint": "Choisissez une période pour recharger l’activité quotidienne et les participations (même plage que Du–Au).",
    "dashboard.chart.range_1m": "1 mo",
    "dashboard.chart.range_3m": "3 mo",
    "dashboard.chart.range_6m": "6 mo",
    "dashboard.chart.range_1y": "1 an",
    "dashboard.chart.range_presets_aria": "Préréglages : 1 mois à 1 an",

    "dashboard.recruiters.preview_title": "Recruteurs",
    "dashboard.recruiters.preview_hint": "Aperçu des fiches. Gérez téléphones et personnel liés sur la page dédiée.",
    "dashboard.recruiters.view_all": "Ouvrir les recruteurs",
    "dashboard.recruiters.none": "Aucun recruteur pour l’instant — ajoutez-en depuis la page recruteurs.",
    "dashboard.recruiters.more_count": "+{n} autres sur la page recruteurs.",
    "dashboard.recruiters.count_subtitle": "{n} dans votre répertoire",
    "dashboard.recruiters.open_team": "Voir les membres du personnel inscrits par ce recruteur",
    "dashboard.leaves.preview_title": "Demandes de congé",
    "dashboard.leaves.preview_hint": "Les demandes en attente en premier. Modifiez le statut ci-dessous ou ouvrez la page complète.",
    "dashboard.leaves.view_all": "Ouvrir les demandes de congé",
    "dashboard.leaves.none": "Aucune demande chargée.",
    "dashboard.leaves.more_count": "+{n} autres sur la page demandes de congé.",
    "auth.sign_in.title": "Bon Retour",
    "auth.sign_in.description": "Entrez votre e-mail et votre mot de passe pour vous connecter",
    "auth.sign_in.email_label": "E-mail",
    "auth.sign_in.email_placeholder": "Entrez votre e-mail",
    "auth.sign_in.password_label": "Mot de passe",
    "auth.sign_in.password_placeholder": "Mot de passe",
    "auth.sign_in.submit": "Se Connecter",
    "auth.sign_in.success_title": "Connexion réussie",
    "auth.sign_in.error_title": "Adresse e-mail ou mot de passe invalide",

    "change_password.title": "Changer le mot de passe",
    "change_password.current_password": "Mot de passe",
    "change_password.new_password": "Confirmez le mot de passe",
    "change_password.save": "ENREGISTRER",
    "change_password.success_title": "Mot de passe changé",
    "change_password.success_text": "Le mot de passe a été changé avec succès.",
    "change_password.error_title": "Erreur",
    "change_password.error_text": "Une erreur s'est produite lors du changement du mot de passe.",

    "users.add_title": "Ajouter un utilisateur",
    "users.edit_title": "Modifier l'utilisateur",
    "users.edit_kicker": "MODIFICATION",
    "users.edit_hint": "Mettez à jour le profil et la zone d'intervention.",
    "users.saving": "Enregistrement...",
    "users.list_title": "Liste des utilisateurs",
    "users.page_kicker": "UTILISATEURS",
    "users.page_hint": "Créez des comptes et gérez les accès par rôle et zone.",
    "users.stats.total": "Total",
    "users.stats.admin": "Administrateurs",
    "users.stats.member": "Agents / membres",
    "users.stats.observer": "Observateurs",
    "users.stats.other": "Autres rôles",
    "users.table_range": "{{start}}–{{end}} sur {{total}} utilisateurs",
    "users.role_other": "Autre",
    "users.table_section_title": "Annuaire des utilisateurs",
    "users.form_show": "Afficher le formulaire",
    "users.form_hide": "Masquer le formulaire",
    "users.form_add": "Ajouter un utilisateur",
    "users.form_section_title": "Nouvel utilisateur",
    "users.table_empty": "Aucun utilisateur à afficher.",
    "users.page_title": "Gestion des utilisateurs",
    "users.first_name": "Prénoms",
    "users.last_name": "Nom de famille",
    "users.title": "Titre",
    "users.title_placeholder": "Ex. Recteur, Inspecteur",
    "users.title_max": "Le titre ne peut pas dépasser 100 caractères",
    "users.email": "E-mail",
    "users.password": "Mot de passe",
    "users.confirm_password": "Confirmez le mot de passe",
    "users.phone": "Téléphone",
    "users.whatsapp": "WhatsApp",
    "users.gender_label": "Sélectionnez le sexe",
    "users.gender_placeholder": "Sélectionner le sexe",
    "users.role_label": "Sélectionner un rôle",
    "users.role_placeholder": "Sélectionner un rôle",
    "users.role_admin": "Administrateur",
    "users.role_user": "Agent de saisie",
    "users.role_auth": "Autre utilisateur",
    "users.role_observator": "Observateur",
    "users.province": "Province",
    "users.province_placeholder": "Sélectionner province",
    "users.department": "Département",
    "users.department_placeholder": "Sélectionner Département",
    "users.select_all_geography": "Tout sélectionner : provinces et départements",
    "users.select_all_departments": "Sélectionner tous les départements",
    "users.save": "ENREGISTRER",
    "users.cancel": "Annuler",
    "users.table.name": "Nom",
    "users.table.title": "Titre",
    "users.table.email": "E-mail",
    "users.table.gender": "Sexe",
    "users.table.role": "Rôle",
    "users.table.phone": "Téléphone",
    "users.table.whatsapp": "WhatsApp",
    "users.table.provinces": "Provinces",
    "users.table.department": "Département",
    "users.table.actions": "Actes",
    "users.create_success_title": "Utilisateur créé",
    "users.create_success_text": "L'utilisateur a été créé avec succès.",
    "users.create_error_title": "Erreur",
    "users.create_error_text": "Une erreur s'est produite lors de la création de l'utilisateur.",
    "users.update_success_title": "Utilisateur mis à jour",
    "users.update_success_text": "L'utilisateur a été mis à jour avec succès.",
    "users.update_error_title": "Erreur",
    "users.update_error_text": "Une erreur s'est produite lors de la mise à jour de l'utilisateur.",
    "users.delete_confirm_title": "Êtes-vous sûr?",
    "users.delete_confirm_text": "Cette action est irréversible!",
    "users.delete_confirm_ok": "Oui, supprimez-le!",
    "users.delete_confirm_cancel": "Annuler",
    "users.delete_success_title": "Supprimé!",
    "users.delete_success_text": "L'utilisateur a été supprimé.",
    "users.delete_error_title": "Erreur",
    "users.delete_error_text": "Une erreur s'est produite lors de la suppression de l'utilisateur.",

    "assignments.title": "Affectation du personnel",
    "assignments.summary_title": "Récapitulatif des affectations",
    "assignments.page_kicker": "AFFECTATIONS",
    "assignments.page_hint": "Liez du personnel aux établissements et consultez l'historique.",
    "assignments.stats.total": "Enregistrements",
    "assignments.stats.teachers": "Personnel distincts",
    "assignments.stats.establishments": "Établissements",
    "assignments.stats.provinces": "Provinces",
    "assignments.stats.this_month": "Ce mois",
    "assignments.stats.today": "Aujourd'hui",
    "assignments.stats.this_week": "Cette semaine",
    "assignments.stats.page_hint": "Résultats filtrés",
    "assignments.server_filters": "Recherche et filtres",
    "assignments.server_filters_hint": "Les filtres sont appliqués côté serveur. Les cartes utilisent les statistiques Stats de l'API.",
    "assignments.search_placeholder": "Rechercher (matricule, nom, téléphone, établissement…)",
    "assignments.status_filter_placeholder": "ex. Active",
    "assignments.filter_all_status": "Tous les statuts",
    "assignments.teacher_filter_count": "{{count}} personne(s) correspondante(s)",
    "assignments.filters_active_count": "{{count}} actif(s)",
    "assignments.viewing_filtered": "{{total}} affectation(s) correspondant aux filtres",
    "assignments.form_section_title": "Nouvelle affectation",
    "assignments.form_show": "Afficher le formulaire",
    "assignments.form_hide": "Masquer le formulaire",
    "assignments.form_add": "Ajouter une affectation",
    "assignments.table_empty": "Aucune affectation à afficher.",
    "assignments.table_range": "{{start}}–{{end}} sur {{total}} lignes",
    "assignments.province": "Province",
    "assignments.province_placeholder": "Sélectionner province",
    "assignments.department": "Département",
    "assignments.department_placeholder": "Sélectionner Département",
    "assignments.subprefecture": "Sous-préfecture",
    "assignments.subprefecture_placeholder": "Sélectionner Sous-préfecture",
    "assignments.establishment": "Établissement",
    "assignments.establishment_placeholder": "Sélectionner Établissement",
    "assignments.teachers": "Personnel à affecter",
    "assignments.teachers_placeholder": "Sélectionner Membre du personnel",
    "assignments.teacher_filter.all": "Tous",
    "assignments.teacher_filter.assigned": "Affectés",
    "assignments.teacher_filter.unassigned": "Non affectés",
    "assignments.date": "Date de l'affectation",
    "assignments.save": "ENREGISTRER",
    "assignments.table.teacher_name": "Nom et prénoms du membre du personnel",
    "assignments.table.teacher_degree": "Diplôme du membre du personnel",
    "assignments.table.subprefecture": "Sous-préfecture",
    "assignments.table.department": "Département",
    "assignments.table.province": "Province",
    "assignments.table.date": "Date de l'affectation",
    "assignments.table.establishment": "Établissement",
    "assignments.table.actions": "Actes",
    "assignments.create_success_title": "Affectation créée",
    "assignments.create_success_text": "L'affectation a été créée avec succès.",
    "assignments.create_error_title": "Erreur",
    "assignments.create_error_text": "Une erreur s'est produite lors de la création de l'affectation.",
    "assignments.reassign_confirm_title": "Enseignant déjà affecté",
    "assignments.reassign_confirm_text": "{{teacher}} est actuellement affecté à {{establishment}}. Voulez-vous l'affecter au nouvel établissement à la place ?",
    "assignments.reassign_confirm": "Oui, réaffecter",
    "assignments.reassign_cancel": "Annuler",
    "assignments.teacher_fallback": "Cet enseignant",
    "assignments.establishment_fallback": "un autre établissement",

    "statistics.title": "Statistiques",
    "statistics.export_pdf": "Exporter au format PDF",
    "statistics.export_excel": "Exporter Excel",
    "statistics.date_label": "Sélectionnez la date",
    "statistics.header_hint": "La recherche actualise les graphiques et tableaux. Le rayon est saisi en mètres et envoyé tel quel à l’API.",
    "statistics.header_hint_tables_first": "Les tableaux listent les chiffres détaillés ; les graphiques ci-dessous résument les mêmes données.",
    "statistics.distance_label": "Rayon de recherche (mètres)",
    "statistics.distance_meters": "Distance (mètres)",
    "statistics.radius_meters_hint": "Rayon en mètres, envoyé tel quel à l’API.",
    "statistics.search": "Recherche",
    "statistics.table.name": "Nom",
    "statistics.table.reported": "Nombre de membres du personnel déclarés",
    "statistics.table.reported_radius": "dans un rayon spécifié",
    "statistics.table.total": "Nombre de membres du personnel Total",
    "statistics.table.total_row": "Totale",
    "statistics.section.establishment": "Établissement",
    "statistics.section.province": "Province",
    "statistics.section.department": "Département",
    "statistics.chart.compare_hint": "Déclarés vs dans le rayon (même échelle pour comparer).",
    "statistics.visual_overview": "Graphiques",
    "statistics.chart.section_intro": "Barres horizontales : déclarés et dans le rayon, sur la même échelle que les tableaux ci-dessus.",
    "statistics.chart.bar_compare_hint": "Déclarés vs dans le rayon — même échelle pour les deux séries.",
    "statistics.chart.type_vertical": "Barres verticales groupées — déclarés vs dans le rayon (différent du tableau de bord en barres horizontales).",
    "statistics.chart.type_doughnut": "Répartition des déclarations par province (vue différente des cartes du tableau de bord).",
    "statistics.chart.type_radar": "Comparaison des deux indicateurs sur les départements (graphique radar).",
    "statistics.pdf.title": "Personnel — rapport statistique",
    "statistics.pdf.page": "Page",
    "statistics.pdf.table_block": "Tableau",
    "statistics.pdf.chart_block": "Graphique",

    "teacher_history.title": "Histoire",

    "teacher_detail.title": "Fiche membre du personnel",
    "teacher_detail.open_profile": "Voir la fiche",
    "teacher_detail.back": "Retour",
    "teacher_detail.view_history": "Historique",
    "teacher_detail.view_map": "Voir sur la carte",
    "teacher_detail.refresh": "Actualiser",
    "teacher_detail.not_found": "Membre du personnel introuvable.",
    "teacher_detail.missing_id": "Identifiant ou matricule requis.",
    "teacher_detail.load_error": "Impossible de charger la fiche membre du personnel.",
    "teacher_detail.licensed": "Licencié",
    "teacher_detail.unlicensed": "Non licencié",
    "teacher_detail.pending_activation": "En attente d'activation",
    "teacher_detail.staff_license_note": "L'activation de licence concerne uniquement le personnel.",
    "teacher_detail.open_licenses": "Ouvrir Licences personnel pour activer",
    "teacher_detail.allocated": "Affecté",
    "teacher_detail.has_attendance": "Avec présence",
    "teacher_detail.score": "Score",
    "teacher_detail.documents": "Documents",
    "teacher_detail.documents_count": "document(s)",
    "teacher_detail.document": "Document",
    "teacher_detail.view_document": "Voir le document",
    "teacher_detail.open_document": "Ouvrir l'original",
    "teacher_detail.download_document": "Télécharger",
    "teacher_detail.document_preview_unavailable": "Aperçu indisponible",
    "teacher_detail.close_document": "Fermer",
    "teacher_detail.kpi.total": "Présences totales",
    "teacher_detail.kpi.this_month": "Ce mois",
    "teacher_detail.kpi.this_week": "Cette semaine",
    "teacher_detail.kpi.last_seen": "Dernière vue",
    "teacher_detail.kpi.within_radius": "Dans le rayon",
    "teacher_detail.section.profile": "Profil",
    "teacher_detail.section.assignment": "Affectation actuelle",
    "teacher_detail.section.ranking": "Classement",
    "teacher_detail.first_attendance": "Première présence",
    "teacher_detail.avg_per_month": "Moy. / mois",
    "teacher_detail.unique_establishments": "Établissements",
    "teacher_detail.establishment": "Établissement",
    "teacher_detail.estab_type": "Type",
    "teacher_detail.assigned_date": "Affecté le",
    "teacher_detail.location": "Localisation",
    "teacher_detail.not_assigned": "Pas d'affectation en cours.",
    "teacher_detail.rank.overall": "Général",
    "teacher_detail.rank.province": "Province",
    "teacher_detail.rank.department": "Département",
    "teacher_detail.last_score": "Dernière mise à jour score",
    "teacher_detail.chart.monthly_title": "Tendance mensuelle",
    "teacher_detail.chart.monthly_desc": "Pointages sur la période sélectionnée",
    "teacher_detail.chart.day_title": "Par jour de la semaine",
    "teacher_detail.chart.day_desc": "Répartition par jour",
    "teacher_detail.chart.estab_title": "Par établissement",
    "teacher_detail.chart.estab_desc": "Part des pointages par école",
    "teacher_detail.chart.monthly": "Présences",
    "teacher_detail.chart.by_day": "Par jour",
    "teacher_detail.chart.by_establishment": "Par établissement",
    "teacher_detail.recent_attendance": "Présences récentes",
    "teacher_detail.records": "enregistrements",
    "teacher_detail.day": "Jour",
    "teacher_detail.radius_status": "Rayon",
    "teacher_detail.no_attendance": "Aucune présence enregistrée.",
    "teacher_detail.export": "Exporter",
    "teacher_detail.export_pdf": "PDF (page)",
    "teacher_detail.export_csv": "CSV (données)",
    "teacher_detail.export_excel": "Excel (données)",
    "teacher_detail.export_error": "Échec de l'export",
    "teacher_detail.export_no_data": "Aucune donnée à exporter.",
    "teacher_detail.export_pdf_title": "Fiche membre du personnel",
    "teacher_detail.export_sheet_overview": "Aperçu",
    "teacher_detail.export_sheet_attendance": "Présences",
    "teacher_detail.export_sheet_monthly": "Mensuel",
    "teacher_detail.export_sheet_by_day": "Par jour",
    "teacher_detail.export_sheet_by_estab": "Par établissement",
    "teacher_detail.export_section_profile": "Profil",
    "teacher_detail.export_section_summary": "Résumé",
    "teacher_detail.export_section_assignment": "Affectation",
    "teacher_detail.export_section_ranking": "Classement",
    "teacher_detail.export_assignment_status": "Statut affectation",
    "teacher_detail.export_latitude": "Latitude",
    "teacher_detail.export_longitude": "Longitude",
    "teacher_detail.export_period": "Période",
    "teacher_detail.export_count": "Nombre",
    "teacher_detail.export_no_data": "Aucune donnée",
    "teacher_detail.export_page": "Page",
    "teacher_detail.export_days_since": "Jours depuis dernière présence",
    "teacher_detail.export_within_radius_count": "Pointages dans le rayon",
    "teacher_detail.export_outside_radius_count": "Pointages hors rayon",
    "teacher_detail.export_field": "Champ",
    "teacher_detail.export_value": "Valeur",
    "teacher_detail.export_csv_error": "Impossible de créer le fichier CSV.",
    "teacher_detail.export_excel_error": "Impossible de créer le fichier Excel.",
    "teacher_detail.export_pdf_error": "Impossible de créer le fichier PDF.",
    "teacher_detail.export_pdf_fallback_title": "PDF créé",
    "teacher_detail.export_pdf_fallback_text": "Un PDF simplifié a été généré car la capture visuelle est bloquée sur ce navigateur.",

    "dashboard.missions_overview": "Aperçu des missions",
    "dashboard.this_month": "ce mois-ci",
    "dashboard.projects.title": "personnel",
    "dashboard.projects.done_this_month": "fait ce mois-ci",
    "dashboard.projects.columns.companies": "ENTREPRISES",
    "dashboard.projects.columns.members": "MEMBRES",
    "dashboard.projects.columns.budget": "BUDGET",
    "dashboard.projects.columns.completion": "ACHÈVEMENT",
    "dashboard.projects.undefined": "Non défini",

    "validation.email_invalid": "Email invalide",
    "validation.email_required": "Email est requis",
    "validation.password_required": "Mot de passe est requis",
    "validation.password_min": "Le mot de passe doit comporter au moins 8 caractères",
    "validation.password_lowercase": "Le mot de passe doit contenir au moins une lettre minuscule ('a'-'z')",
    "validation.password_uppercase": "Le mot de passe doit contenir au moins une lettre majuscule ('A'-'Z')",
    "validation.password_special": "Le mot de passe doit contenir au moins un caractère non alphanumérique",
    "validation.password_match": "Les mots de passe doivent correspondre",
    "validation.confirm_password_required": "Confirmation du mot de passe est requise",
    "validation.first_name_required": "Prénom est requis",
    "validation.last_name_required": "Nom de famille est requis",
    "validation.gender_required": "Genre est requis",
    "validation.phone_required": "Numéro de téléphone est requis",
    "validation.role_required": "Rôle est requis",
    "validation.current_password_required": "Mot de passe actuel est requis",
    "validation.new_password_required": "Nouveau mot de passe est requis",
    "validation.province_required": "Province est requis",
    "validation.department_required": "Département est requis",
    "validation.subprefecture_required": "Sous-préfecture est requis",
    "validation.establishment_required": "Établissement est requis",
    "validation.teachers_required": "Personnel à affecter est requis",
    "validation.assignment_date_required": "Date de l'affectation est requis",

    "assistant.title": "Assistant eVerifPro",
    "assistant.subtitle": "Sécurisé · sur site",
    "assistant.open": "Ouvrir l'assistant",
    "assistant.open_tooltip": "Assistant eVerifPro (⌘K)",
    "assistant.expand": "Plein écran",
    "assistant.collapse": "Réduire",
    "assistant.page_title": "Assistant eVerifPro",
    "assistant.page_subtitle": "Plein écran — même conversation que le panneau flottant. Réduisez pour revenir.",
    "assistant.placeholder": "Posez une question…",
    "assistant.hint": "Entrée envoyer · Maj+Entrée nouvelle ligne · ⌘K basculer",
    "assistant.hint_page": "Entrée envoyer · Maj+Entrée nouvelle ligne · Réduire pour le panneau flottant",
    "assistant.clear": "Effacer la conversation",
    "assistant.refresh": "Actualiser les alertes",
    "assistant.action.open": "Ouvrir",
    "assistant.action.view_teachers": "Voir personnel",
    "assistant.action.view_recruiters": "Voir recruteurs",
    "assistant.action.view_assignments": "Voir affectations",
    "assistant.action.view_establishments": "Voir établissements",
    "assistant.action.view_dashboard": "Tableau de bord",
    "assistant.action.view_stats": "Statistiques",
    "assistant.action.review_leaves": "Voir les congés",
    "assistant.action.leave_guide": "Guide congé",
    "assistant.action.next_step": "Étape suivante",
    "assistant.action.open_page": "Ouvrir la page",
    "assistant.action.help_page": "Aide cette page",
    "assistant.prompts_label": "Je peux vous aider avec",
    "assistant.prompts_commands_label": "Actions rapides",
    "assistant.generating_summary": "Génération de la réponse en cours…",
    "assistant.writing_answer": "Rédaction de la réponse…",
    "assistant.llm_online": "Prêt à vous aider",
    "assistant.llm_offline": "Hors ligne",
    "assistant.llm_checking": "Connexion…",
    "assistant.llm_online_hybrid": "Prêt à vous aider",
    "assistant.llm_smart_routing": "Mode conversation avancé",
    "assistant.llm_writing": "Un instant…",
    "assistant.llm_streaming": "Un instant…",
    "assistant.ai_routing_on": "Compréhension conversationnelle améliorée",
    "assistant.ai_routing_off": "Réponses rapides (mode standard)",
    "assistant.gemini_online": "Gemini cloud · prêt",
    "assistant.gemini_on": "IA Gemini cloud (rapide). Données envoyées à Google.",
    "assistant.gemini_off": "IA locale Ollama (privée, plus lente sur ce serveur)",
    "assistant.gemini_need_smart": "Activez Smart AI pour utiliser Gemini",
    "assistant.mode_dialog_title": "Mode de réponse de l'assistant",
    "assistant.mode_dialog_hint": "Choisissez comment l'assistant répond. Vous pouvez changer à tout moment.",
    "assistant.mode_dialog_open": "Changer le mode de réponse",
    "assistant.mode_dialog_done": "Terminé",
    "assistant.mode_rules_title": "Standard",
    "assistant.mode_rules_desc": "Réponses instantanées via règles et données live du portail. Recommandé au quotidien.",
    "assistant.mode_rules_subtitle": "Règles & données live · instantané",
    "assistant.mode_local_title": "IA locale",
    "assistant.mode_local_desc": "Ollama sur votre serveur. Privé — aucune donnée ne quitse le réseau. Peut être plus lent.",
    "assistant.mode_local_subtitle": "IA locale · sur site",
    "assistant.mode_local_offline": " · Ollama hors ligne",
    "assistant.mode_gemini_title": "IA cloud (Gemini)",
    "assistant.mode_gemini_desc": "Google Gemini — réponses rapides. Texte anonymisé envoyé à l'API Google.",
    "assistant.mode_gemini_offline": " · indisponible",
    "assistant.mode_gemini_unconfigured": " · non configuré sur le serveur",
    "assistant.tour_open": "Visite guidée",
    "assistant.tour_prompt": "Visite guidée",
    "assistant.insight.pending_leaves": "{{count}} demande(s) de congé en attente",
    "assistant.insight.teacher_roster": "{{count}} membre du personnel(s) inscrite(s)",
    "assistant.insight.recruiters": "{{count}} recruteur(s) actifs",
    "assistant.insight.assignments": "{{count}} affectation(s) enregistrée(s)",
    "assistant.insight.license_exhausted": "Plus de licences disponibles — {{count}} membre du personnel(s) en attente d'activation",
    "assistant.action.view_teacher_licenses": "Ouvrir licences personnel",
  },
  en: {
    "nav.dashboard": "Dashboard",
    "nav.home": "Home",
    "nav.teachers": "Teachers",
    "nav.teacher_license": "Personnel Licenses",
    "nav.affectations": "Assignments",
    "nav.establishments": "Establishments",
    "nav.statistics": "Statistics",
    "nav.users": "User Management",
    "nav.leave_requests": "Leave Requests",
    "nav.recruiters": "Recruiters",
    "nav.establishment_attendance": "Establishment attendance",
    "nav.area_attendance": "Area attendance summary",
    "nav.notifications": "Notifications",
    "nav.settings": "Settings",
    "nav.assistant": "Assistant",
    "nav.change_password": "Change Password",
    "nav.teacher_history": "Teacher History",
    "nav.teacher_detail": "Teacher profile",
    "nav.sign_in": "Sign In",
    "nav.sign_up": "Sign Up",

    "navbar.welcome": "Welcome",
    "navbar.change_password": "Change password",
    "navbar.logout": "Log out",
    "navbar.logout_title": "Logged out",
    "navbar.logout_success": "You have been logged out successfully.",
    "navbar.view_establishments": "View Establishments",
    "navbar.language": "Language",

    "recruiters.title": "Recruiters",
    "recruiters.add": "Add recruiter",
    "recruiters.none": "No recruiters found.",
    "recruiters.name": "Name",
    "recruiters.phone": "Phone",
    "recruiters.whatsapp": "WhatsApp",
    "recruiters.username": "Username",
    "recruiters.actions": "Actions",
    "recruiters.edit": "Edit recruiter",
    "recruiters.add_modal": "Add recruiter",
    "recruiters.save": "Save",
    "recruiters.update": "Update",
    "recruiters.cancel": "Cancel",
    "recruiters.teachers": "Teachers",
    "recruiters.teachers.none": "No teachers found.",
    "recruiters.teachers.reg": "Reg #",
    "recruiters.teachers.first": "First name",
    "recruiters.teachers.last": "Last name",
    "recruiters.teachers.gender": "Gender",
    "recruiters.teachers.degree": "Degree",
    "recruiters.teachers.phone": "Phone",
    "recruiters.teachers.whatsapp": "WhatsApp",
    "recruiters.teachers.email": "Email",
    "recruiters.close": "Close",
    "recruiters.page_kicker": "RECRUITMENT",
    "recruiters.page_hint": "Manage recruiters, contact details, and linked teachers.",
    "recruiters.stats.total": "Total recruiters",
    "recruiters.stats.whatsapp": "With WhatsApp",
    "recruiters.stats.username": "User accounts",
    "recruiters.stats.with_phone": "With phone",
    "recruiters.stats.with_email": "With email",
    "recruiters.table_title": "Recruiter directory",
    "recruiters.load_error": "Failed to load recruiters.",

    "teacher_license.title": "Personnel Licenses",
    "teacher_license.subtitle": "Activate registered teachers and staff before they can sign in or mark attendance. Registration is unlimited; only licensed personnel can use the app.",
    "teacher_license.stats.total": "Total registered",
    "teacher_license.stats.licensed": "Licensed",
    "teacher_license.stats.pending": "Pending activation",
    "teacher_license.stats.max_licensed": "Max licensed",
    "teacher_license.stats.remaining": "Remaining licenses",
    "teacher_license.filters": "Filters",
    "teacher_license.province": "Province",
    "teacher_license.province_placeholder": "Select province",
    "teacher_license.department": "Department",
    "teacher_license.department_placeholder": "Select department",
    "teacher_license.subprefecture": "Sub-prefecture",
    "teacher_license.subprefecture_placeholder": "Select sub-prefecture",
    "teacher_license.establishment": "Establishment",
    "teacher_license.establishment_placeholder": "Select establishment",
    "teacher_license.status": "Status",
    "teacher_license.status.all": "All",
    "teacher_license.status.licensed": "Licensed",
    "teacher_license.status.pending": "Pending activation",
    "teacher_license.matricule": "Matricule",
    "teacher_license.matricule_placeholder": "Search on current page…",
    "teacher_license.apply": "Apply",
    "teacher_license.reset": "Reset",
    "teacher_license.bulk.activate": "Activate filtered",
    "teacher_license.bulk.deactivate": "Deactivate filtered",
    "teacher_license.bulk.geo_required": "Select at least one geographic filter for bulk actions.",
    "teacher_license.bulk.geo_note": "Bulk actions only affect teachers and staff with an active establishment assignment in the selected area.",
    "teacher_license.bulk.confirm_activate": "Activate filtered teachers?",
    "teacher_license.bulk.confirm_deactivate": "Deactivate filtered teachers?",
    "teacher_license.bulk.scope": "Scope:",
    "teacher_license.scope.all": "All personnel (no geographic filter)",
    "teacher_license.col.reg": "Matricule",
    "teacher_license.col.name": "Name",
    "teacher_license.col.phone": "Phone",
    "teacher_license.col.province": "Province",
    "teacher_license.col.department": "Department",
    "teacher_license.col.subprefecture": "Sub-prefecture",
    "teacher_license.col.establishment": "Establishment",
    "teacher_license.col.reg_date": "Reg. date",
    "teacher_license.col.type": "Type",
    "teacher_license.col.status": "Status",
    "teacher_license.col.actions": "Actions",
    "teacher_license.none": "No personnel found.",
    "teacher_license.action.activate": "Activate",
    "teacher_license.action.deactivate": "Deactivate",
    "teacher_license.updated": "Updated.",
    "teacher_license.error.load": "Unable to load personnel.",
    "teacher_license.error.update": "Unable to update license.",
    "teacher_license.error.missing_db_id": "Could not resolve teacher database id from this row. Use the numeric id from the API list, not matricule.",
    "teacher_license.not_applicable": "N/A",
    "teacher_license.staff_not_applicable": "Licensing applies to teachers and staff.",
    "teacher_license.cancel": "Cancel",
    "teacher_license.confirm": "Confirm",
    "pagination.rows_per_page": "Rows per page",

    "establishments.title": "Establishments",
    "establishments.page_kicker": "DIRECTORY",
    "establishments.page_hint": "Browse, create, and manage establishments.",
    "establishments.add": "Add establishment",
    "establishments.import_csv": "Import CSV",
    "establishments.table_title": "Establishment list",
    "establishments.table_range": "{{start}}–{{end}} of {{total}} establishments",
    "establishments.none": "No establishments found.",
    "establishments.load_error": "Failed to load establishments.",
    "establishments.col.name": "Name",
    "establishments.col.code": "Code",
    "establishments.col.type": "Type",
    "establishments.col.status": "Status",
    "establishments.col.subprefecture": "Sub-prefecture",
    "establishments.col.coordinates": "Coordinates",
    "establishments.actions": "Actions",
    "establishments.detail_title": "Establishment details",
    "establishments.add_modal": "Add establishment",
    "establishments.edit_modal": "Edit establishment",
    "establishments.field.creation_date": "Creation date",
    "establishments.field.latitude": "Latitude",
    "establishments.field.longitude": "Longitude",
    "establishments.field.attendance_count": "Attendance count",
    "establishments.map_hint": "Click on the map to set the establishment location.",
    "establishments.save": "Save",
    "establishments.cancel": "Cancel",
    "establishments.close": "Close",
    "establishments.stats.total": "Total establishments",
    "establishments.stats.page": "On this page",
    "establishments.create_success_title": "Saved",
    "establishments.create_success": "Establishment created successfully.",
    "establishments.create_error": "Failed to create establishment.",
    "establishments.update_success": "Establishment updated successfully.",
    "establishments.update_error": "Failed to update establishment.",
    "establishments.detail_error": "Failed to load establishment details.",
    "establishments.delete_confirm_title": "Archive establishment?",
    "establishments.delete_confirm_text": "This action cannot be undone.",
    "establishments.delete_warning_text": "You are about to archive “{{name}}” (code: {{code}}). Impact: {{assignments}} assignments ({{active}} active) and {{attendance}} attendance records.",
    "establishments.delete_continue": "Continue",
    "establishments.delete_type_name_title": "Confirm the establishment",
    "establishments.delete_type_name_text": "Type the exact establishment name: “{{name}}”",
    "establishments.delete_verify": "Verify",
    "establishments.delete_name_mismatch": "The establishment name does not match exactly.",
    "establishments.delete_reason_title": "Reason for archiving",
    "establishments.delete_reason_text": "Enter a clear reason. It will be stored in the establishment audit record.",
    "establishments.delete_reason_placeholder": "Reason",
    "establishments.delete_reason_required": "A reason is required.",
    "establishments.delete_final_title": "Final archive confirmation",
    "establishments.delete_final_text": "Type “{{phrase}}” to archive this establishment.",
    "establishments.delete_phrase_mismatch": "The confirmation phrase does not match exactly.",
    "establishments.delete_confirm_yes": "Archive establishment",
    "establishments.delete_success_title": "Archived",
    "establishments.delete_success": "Establishment archived successfully.",
    "establishments.delete_error": "Failed to archive establishment.",
    "establishments.impact_error": "Could not verify the archive impact.",
    "establishments.error_title": "Error",
    "establishments.search_placeholder": "Search establishments…",
    "establishments.search_results": "{{shown}} of {{total}} establishments",
    "establishments.search_none": "No establishments match your search.",
    "establishments.loaded_count": "{{count}} establishments loaded",

    "recruiters.teachers_count": "{{n}} linked teacher(s)",
    "recruiters.form_hint_add": "Create a recruiter with login credentials.",
    "recruiters.form_hint_edit": "Update this recruiter's contact details.",
    "recruiters.teachers_modal_kicker": "TEAM",
    "recruiters.teachers_modal_hint": "Teachers assigned to this recruiter.",
    "recruiters.teachers_contact_hint": "{{phone}} with phone · {{email}} with email · {{wa}} with WhatsApp",

    "notifications.title": "Push notifications",
    "notifications.page_kicker": "COMMUNICATIONS",
    "notifications.page_hint": "Send mobile push notifications to teachers, panel users, or recruiters.",
    "notifications.tab.teachers": "Teachers",
    "notifications.tab.users": "Panel users",
    "notifications.tab.recruiters": "Recruiters",
    "notifications.field.title": "Title",
    "notifications.field.title_placeholder": "Notification title",
    "notifications.field.body": "Message",
    "notifications.field.body_placeholder": "Write the notification message…",
    "notifications.audience": "Audience",
    "notifications.scope.all": "All teachers",
    "notifications.scope.filtered": "By location",
    "notifications.province": "Province",
    "notifications.province_placeholder": "Select province",
    "notifications.department": "Department",
    "notifications.department_placeholder": "Select department",
    "notifications.subprefecture": "Sub-prefecture",
    "notifications.subprefecture_placeholder": "Select sub-prefecture",
    "notifications.establishment": "Establishment",
    "notifications.establishment_placeholder": "Select establishment",
    "notifications.provinces": "Provinces",
    "notifications.provinces_placeholder": "Select one or more provinces",
    "notifications.departments": "Departments",
    "notifications.departments_placeholder": "Select one or more departments",
    "notifications.subprefectures": "Sub-prefectures",
    "notifications.subprefectures_placeholder": "Select one or more sub-prefectures",
    "notifications.establishments": "Establishments",
    "notifications.establishments_placeholder": "Select one or more establishments",
    "notifications.device_types": "Device types",
    "notifications.device.android": "Android",
    "notifications.device.ios": "iOS",
    "notifications.device_hint": "Sent to selected platforms only (Android = 1, iOS = 2).",
    "notifications.filtered_hint": "Select provinces first, then optionally narrow by department, sub-prefecture, or establishment.",
    "notifications.selected_count": "{{n}} selected",
    "notifications.error.device_required": "Select at least one device type (Android or iOS).",
    "notifications.error.filtered_required": "Select at least one location filter (province, department, sub-prefecture, or establishment).",
    "notifications.error.preview_teachers_unavailable": "Recipient preview is not available for teacher notifications. Review your filters and send when ready.",
    "notifications.error.preview_unavailable": "Recipient preview is not available. Review your filters and send when ready.",
    "notifications.users_hint": "Send to panel users (admins) filtered by province, department, sub-prefecture, and/or establishment.",
    "notifications.role": "Role",
    "notifications.role_placeholder": "Select role",
    "notifications.recruiters_hint": "This notification will be sent to all registered recruiters with a valid push token.",
    "notifications.preview": "Preview recipients",
    "notifications.previewing": "Estimating…",
    "notifications.send": "Send notification",
    "notifications.sending": "Sending…",
    "notifications.cancel": "Cancel",
    "notifications.recipient_count": "{{count}} recipient(s)",
    "notifications.send_confirm_title": "Send push notification?",
    "notifications.send_confirm_text": "This will send « {{title}} » to {{audience}}. Continue?",
    "notifications.send_success_title": "Notification sent",
    "notifications.send_success_text": "Delivered to {{count}} recipient(s).",
    "notifications.history_title": "Sent notifications",
    "notifications.history.subtitle": "{{total}} job(s) total",
    "notifications.history.date": "Date",
    "notifications.history.audience": "Audience",
    "notifications.history.notification": "Notification",
    "notifications.history.delivery": "Delivery",
    "notifications.history.recipients": "Recipients",
    "notifications.history.status": "Status",
    "notifications.history.requested": "Requested",
    "notifications.history.started": "Started",
    "notifications.history.completed": "Completed",
    "notifications.history.job_id": "Job ID",
    "notifications.history.filters": "Filters",
    "notifications.history.details": "Details",
    "notifications.history.failed_short": "failed",
    "notifications.history.summary_completed": "{{n}} completed",
    "notifications.history.summary_failed": "{{n}} failed",
    "notifications.history.summary_delivered": "{{n}} delivered",
    "notifications.history.empty": "No notifications sent yet.",
    "notifications.error.title_required": "Title is required.",
    "notifications.error.body_required": "Message is required.",
    "notifications.error.province_required": "Select a province.",
    "notifications.error.department_required": "Select province and department.",
    "notifications.error.subprefecture_required": "Select province, department and sub-prefecture.",
    "notifications.error.establishment_required": "Select the full location down to establishment.",
    "notifications.error.user_filters_required": "Province, department and role are required.",
    "notifications.error.admin_filters_required": "Select at least one location filter for panel users.",
    "notifications.error.preview_failed": "Could not estimate recipients. The notification API may not be available yet.",
    "notifications.error.send_failed": "Failed to send notification.",

    "settings.title": "Settings",
    "settings.page_kicker": "ADMINISTRATION",
    "settings.page_hint": "Manage your account preferences and import establishment data.",
    "settings.account.title": "Account",
    "settings.account.name": "Name",
    "settings.account.email": "Email",
    "settings.account.role": "Role",
    "settings.preferences.title": "Preferences",
    "settings.preferences.language_hint": "Applies immediately across the admin panel.",
    "settings.quick.title": "Quick links",
    "settings.quick.change_password_hint": "Update your account password.",
    "settings.quick.users_hint": "Manage panel users and roles.",
    "settings.quick.notifications_hint": "Send push notifications.",
    "settings.radius.title": "Attendance radius",
    "settings.radius.subtitle": "Set the preferred check-in distance for the mobile app.",
    "settings.radius.loading": "Loading attendance policy…",
    "settings.radius.meters": "meters",
    "settings.radius.preferred_distance": "Preferred distance",
    "settings.radius.validation": "Enter a value from 1 to 100,000 meters.",
    "settings.radius.input_hint": "Allowed range: 1–100,000 meters",
    "settings.radius.future_only": "This value applies to future attendance records. Existing records keep the radius captured when they were created.",
    "settings.radius.save": "Save radius",
    "settings.radius.saving": "Saving…",
    "settings.radius.success": "Attendance radius updated successfully.",
    "settings.radius.error_load": "Could not load the current attendance radius.",
    "settings.radius.error_save": "Could not update the attendance radius. Please try again.",
    "settings.radius.last_updated": "Last updated",
    "settings.import.title": "Import establishments",
    "settings.import.subtitle": "Upload a CSV file through the secured web API.",
    "settings.import.hint": "CSV must include province, department, sub-prefecture, establishment name, type, status, coordinates and code.",
    "settings.import.download_template": "Download template",
    "settings.import.drop_hint": "Drag & drop a CSV file here",
    "settings.import.or_browse": "or browse from your computer",
    "settings.import.browse": "Browse CSV",
    "settings.import.clear": "Clear",
    "settings.import.preview": "Preview",
    "settings.import.rows": "rows",
    "settings.import.columns_title": "Required CSV columns",
    "settings.import.column": "Column",
    "settings.import.example": "Example",
    "settings.import.upload": "Import establishments",
    "settings.import.uploading": "Importing…",
    "settings.import.cancel": "Cancel",
    "settings.import.confirm_title": "Import establishments?",
    "settings.import.confirm_text": "This will upload « {{file}} » to the server.",
    "settings.import.success_title": "Import successful",
    "settings.import.success_text": "Establishments were imported successfully.",
    "settings.import.success_redirect": "Establishments were imported. Opening the list…",
    "settings.import.success_generic": "Import completed.",
    "settings.import.error_title": "Import failed",
    "settings.import.error_upload": "Import failed. Check the CSV format and try again.",
    "settings.import.error_csv_only": "Please select a .csv file.",
    "settings.import.error_no_file": "Select a CSV file first.",
    "settings.import.error_empty": "The CSV file is empty.",
    "settings.import.error_read": "Could not read the CSV file.",
    "settings.import.error_missing_columns": "Missing required columns: {{cols}}",
    "settings.import.result_imported": "Imported",
    "settings.import.result_failed": "Failed",

    "map.select_establishment": "Select establishment",
    "map.all_establishments": "All establishments on map",
    "map.no_teachers": "No teachers found for this date.",
    "map.teachers_at_establishment": "Teachers",
    "map.click_for_teachers": "Click to load teachers.",
    "map.establishments_on_map": "{{count}} establishment(s) on map",
    "map.focused_establishment": "1 establishment shown",
    "map.loading_teachers": "Loading teachers…",
    "map.teachers_shown": "{{count}} teacher check-in(s)",
    "map.click_establishment_hint": "Click an establishment to see teacher links.",
    "map.view_profile": "View Profile",
    "map.view_more_teachers": "View {{count}} more",
    "map.show_less_teachers": "Show less",
    "map.select_establishment_placeholder": "Select establishment",
    "map.select_area_hint": "Select province, department and sub-prefecture to show establishments.",
    "map.attendance_count": "Attendance count",
    "map.attendance_high": "Higher attendance",
    "map.attendance_low": "Lower attendance",
    "map.clear_selection": "Show all establishments",
    "map.filter.attend_date": "Attendance date",
    "map.filter.radius": "Radius (m)",
    "map.filter.view_mode": "View",
    "map.filter.category": "Category",
    "map.filter.category_all": "All categories",
    "map.filter.radius_filter": "Radius filter",
    "map.filter.radius_all": "All",
    "map.filter.show_advanced": "Filters",
    "map.filter.hide_advanced": "Less",
    "map.filter.reset_advanced": "Reset filters",
    "map.filter.all_genders": "All genders",
    "map.filter.all_degrees": "All degrees",
    "map.filter.degree": "Degree",
    "map.filter.employment_status": "Status",
    "map.filter.all_statuses": "All statuses",
    "map.drawer.title": "Map filters",
    "map.drawer.subtitle": "Refine what appears on the map without leaving the view.",
    "map.drawer.close": "Close",
    "map.drawer.apply": "Done",
    "map.drawer.results_of": "of {{total}} check-in(s) shown",
    "map.drawer.section_display": "Map display",
    "map.drawer.section_display_hint": "Choose how teacher locations are drawn.",
    "map.drawer.section_distance": "Distance & presence",
    "map.drawer.section_distance_hint": "Define how close a check-in must be to count as at school.",
    "map.drawer.section_teacher": "Teacher profile",
    "map.drawer.section_teacher_hint": "Filter by type, status, gender, contract type, or degree.",
    "map.drawer.only_in_radius": "Only inside radius",
    "map.drawer.only_out_radius": "Only outside radius",
    "map.drawer.legend": "Legend",
    "map.drawer.legend_in": "Green — check-in inside allowed radius",
    "map.drawer.legend_out": "Orange — check-in outside allowed radius",
    "map.drawer.view_hint.markers": "One dot per teacher, colored by distance from school.",
    "map.drawer.view_hint.cluster": "Groups nearby teachers with a count badge.",
    "map.drawer.view_hint.heatmap": "Colored zones showing check-in density.",
    "map.drawer.view_hint.lines": "Draws a line from school to each teacher check-in.",
    "map.view.markers": "Markers",
    "map.view.cluster": "Clusters",
    "map.view.heatmap": "Heatmap",
    "map.view.lines": "Lines",
    "map.kpi.in_radius": "In radius",
    "map.kpi.out_radius": "Out of radius",
    "map.kpi.check_in_rate": "Check-in rate",
    "map.view_history": "View history",
    "map.popup.distance": "Distance",
    "map.popup.establishment": "Establishment",
    "map.area_view_active": "Area view — all establishments",
    "map.export": "Export filtered teachers",
    "map.panel.show": "Regional summary",
    "map.panel.hide": "Hide panel",
    "map.panel.title": "Regional attendance",
    "map.panel.hint": "Compare assigned vs checked-in teachers for the selected zone and period.",
    "map.panel.loading": "Loading…",
    "map.panel.province": "Province",
    "map.panel.assigned": "Assigned",
    "map.panel.checked": "Checked",
    "map.widget.kicker": "GEO DISTRIBUTION",
    "map.widget.title": "Teacher map",
    "map.widget.hint": "Explore teacher check-ins on the map with geo filters, radius, heatmap, and export.",
    "map.widget.open": "Open teacher distribution map",
    "nav.teacher_map": "Teacher map",
    "map.select_teacher": "Teacher",
    "map.all_teachers_at_school": "All teachers at school",
    "map.clear_teacher": "All teachers at school",
    "map.filter.start_date": "From",
    "map.filter.end_date": "To",
    "map.popup.date": "Date",
    "map.mode.teacher_timeline": "Teacher timeline",
    "map.mode.school_overview": "School overview",
    "map.mode.area_overview": "Area overview",
    "map.teachers_shown_day": "{{count}} on {{day}}",
    "map.drawer.view_context_teacher": "Lines show this teacher's check-ins to the school. Heatmap uses this teacher only.",
    "map.drawer.view_context_school": "Lines link the school to each teacher check-in. Heatmap uses all teachers shown.",
    "map.drawer.view_context_area": "Overview of all schools in the sub-prefecture.",
    "map.timeline.days": "days",
    "map.timeline.check_ins": "check-ins",
    "map.timeline.all_days": "All",
    "map.timeline.prev": "Previous day",
    "map.timeline.next": "Next day",

    "leave.title": "Leave Requests",
    "leave.add": "Add leave request",
    "leave.none": "No leave requests found.",
    "leave.teacher": "Teacher Name",
    "leave.type": "Leave Type",
    "leave.start": "Start Date",
    "leave.end": "End Date",
    "leave.reason": "Reason",
    "leave.status": "Status",
    "leave.reviewed": "Reviewed On",
    "leave.actions": "Actions",
    "leave.view": "View",
    "leave.update_status": "Update Status",
    "leave.details": "Leave Request Details",
    "leave.status_title": "Update Status",
    "leave.status_hint": "Choose a status for this leave request.",
    "leave.cancel": "Cancel",
    "leave.save": "Save",
    "leave.saving": "Saving...",
    "leave.add_title": "Add Leave Request",
    "leave.select_teacher": "Select teacher",
    "leave.select_type": "Select leave type",
    "leave.reason_placeholder": "Add a short reason for this request",
    "leave.page_kicker": "LEAVE",
    "leave.page_hint": "Track requests and update statuses from this view.",
    "leave.stats.total": "Requests",
    "leave.stats.pending": "Pending",
    "leave.stats.approved": "Approved",
    "leave.stats.rejected": "Rejected",
    "leave.stats.cancelled": "Cancelled",
    "leave.table_range": "{{start}}–{{end}} of {{total}} requests",
    "leave.table_title": "All requests",
    "leave.modal_form_kicker": "NEW REQUEST",
    "leave.modal_form_hint": "Fill required fields. Dates define the leave period.",
    "leave.detail_kicker": "DETAIL",
    "leave.detail_hint": "Summary of this request and reason.",

    "status.Pending": "Pending",
    "status.Approved": "Approved",
    "status.Rejected": "Rejected",
    "status.Cancelled": "Cancelled",
    "status.active": "Active",
    "status.inactive": "Inactive",
    "gender.male": "Male",
    "gender.female": "Female",

    "teachers.title": "Add new teacher",
    "teachers.form_hint": "Create or update a teacher record.",
    "teachers.list": "Teachers list",
    "teachers.list_subtitle": "Overview of teaching staff and quick actions.",
    "teachers.recruiter": "Recruiter",
    "teachers.recruiter_select": "Select recruiter",
    "teachers.cancel": "Cancel",
    "teachers.save": "Save",
    "teachers.loading": "Loading...",
    "teachers.name": "Name",
    "teachers.firstname": "First name",
    "teachers.gender": "Select gender",
    "teachers.gender_placeholder": "Select gender",
    "teachers.reg_date": "Registration date",
    "teachers.degree": "Degree",
    "teachers.phone": "Phone",
    "teachers.dob": "Date of birth",
    "teachers.status": "Select status",
    "teachers.status_placeholder": "Select status",
    "teachers.certificate": "Certificate",
    "teachers.reg_number": "Registry number",
    "teachers.identification": "Identification number",
    "teachers.integration_order": "Integration order number",
    "teachers.table.reg": "Teacher reg #",
    "teachers.table.name": "Teacher name",
    "teachers.table.gender": "Teacher gender",
    "teachers.table.status": "Teacher status",
    "teachers.table.type": "Type",
    "teachers.filter.type": "Type",
    "teachers.type.all": "All",
    "teachers.type.teacher": "Teacher",
    "teachers.type.staff": "Staff",
    "teachers.person_type": "Person type",
    "teachers.table.license": "License",
    "teachers.license.licensed": "Licensed",
    "teachers.license.pending": "Pending activation",
    "teachers.register_success_title": "Teacher registered",
    "teachers.register_success": "Teacher registered successfully. Awaiting license activation.",
    "teachers.register_staff_success_title": "Staff registered",
    "teachers.register_staff_success": "Staff member registered successfully. Awaiting license activation.",
    "teachers.table.degree": "Teacher degree",
    "teachers.table.phone": "Phone",
    "teachers.table.whatsapp": "WhatsApp",
    "teachers.table.email": "Email",
    "teachers.table.action": "Action",
    "teachers.none": "No teachers to display.",
    "teachers.none_filtered": "No teachers match the selected filters.",
    "teachers.export_filtered": "Export filtered",
    "teachers.export_error": "Export failed",
    "teachers.export_error_hint": "Could not load teachers for export.",
    "teachers.server_filters": "Search & filters",
    "teachers.server_filters_hint": "Filters run on the server. Tab counts use stats.categoryCounts from the API.",
    "teachers.search_placeholder": "Search all columns…",
    "teachers.filters_show": "Advanced filters",
    "teachers.filters_hide": "Hide advanced",
    "teachers.status_filter_placeholder": "e.g. Contractor",
    "teachers.recruiter_all": "All recruiters",
    "teachers.recruiter_name": "Recruiter name",
    "teachers.whatsapp": "WhatsApp",
    "teachers.email": "Email",
    "teachers.phone_placeholder": "Phone number",
    "teachers.whatsapp_placeholder": "WhatsApp number",
    "teachers.email_placeholder": "Email address",
    "teachers.filters_minimize": "Minimize filters",
    "teachers.filters_expand": "Show filters",
    "teachers.filters_active_count": "{{count}} active",
    "teachers.filtered_count_server": "{{count}} matching (server-side)",
    "teachers.count_suffix": "teacher(s)",
    "teachers.refresh": "Refresh list",
    "teachers.edit_row": "Edit",
    "teachers.stats.total": "Total",
    "teachers.stats.male": "Male",
    "teachers.stats.female": "Female",
    "teachers.stats.recruiter": "With recruiter",
    "teachers.stats.total_enrolled": "Total enrolled",
    "teachers.stats.category_results": "Filter results",
    "teachers.category.filter_label": "Filter by status",
    "teachers.category.all": "All teachers",
    "teachers.category.not_assigned": "Enrolled, not assigned",
    "teachers.category.assigned": "Enrolled and assigned",
    "teachers.category.assigned_with_attendance": "Assigned with attendance",
    "teachers.category.all_desc": "Every enrolled teacher in the system.",
    "teachers.category.not_assigned_desc": "Registered but not yet linked to an establishment.",
    "teachers.category.assigned_desc": "Linked to at least one establishment.",
    "teachers.category.assigned_with_attendance_desc": "Assigned with at least one attendance recorded.",
    "teachers.pipeline.kicker": "ENROLLMENT PIPELINE",
    "teachers.pipeline.hint": "Track enrollment from registration through assignment and first attendance. Select a stage to filter the list.",
    "teachers.pipeline.enrolled_total": "{{count}} enrolled",
    "teachers.pipeline.share": "{{pct}}% of enrolled",
    "teachers.pipeline.viewing": "{{count}} teachers — {{label}}",
    "teachers.pipeline.active_filter": "Active",
    "teachers.pipeline.legend_not_assigned": "Not assigned",
    "teachers.pipeline.legend_assigned_pending": "Assigned, no attendance yet",
    "teachers.pipeline.legend_with_attendance": "Assigned with attendance",
    "teachers.table.allocated": "Assigned",
    "teachers.table.attendance": "Attendance",
    "teachers.allocated.yes": "Yes",
    "teachers.allocated.no": "No",
    "teachers.attendance.yes": "Yes",
    "teachers.attendance.no": "No",
    "estab_attendance.page_kicker": "ATTENDANCE REPORT",
    "estab_attendance.title": "Establishment attendance report",
    "estab_attendance.page_hint": "Select dates and radius to review teacher attendance. Optionally filter by establishment — leave empty to load all teachers.",
    "estab_attendance.province": "Province",
    "estab_attendance.department": "Department",
    "estab_attendance.subprefecture": "Sub-prefecture",
    "estab_attendance.establishment": "Establishment",
    "estab_attendance.select_province": "Select province",
    "estab_attendance.select_department": "Select department",
    "estab_attendance.select_subprefecture": "Select sub-prefecture",
    "estab_attendance.select_establishment": "Select establishment",
    "estab_attendance.start_date": "Start date",
    "estab_attendance.end_date": "End date",
    "estab_attendance.radius": "Radius (meters)",
    "estab_attendance.radius_hint": "Maximum distance from establishment to count as in-radius.",
    "estab_attendance.search": "Generate report",
    "estab_attendance.error.establishment": "Please select an establishment.",
    "estab_attendance.error.dates": "Please select start and end dates.",
    "estab_attendance.error.date_order": "Start date must be before end date.",
    "estab_attendance.error.radius": "Please enter a valid radius in meters.",
    "estab_attendance.error.load": "Failed to load the attendance report.",
    "estab_attendance.no_teachers": "No teachers found for this establishment in the selected period.",
    "estab_attendance.no_calendar": "No attendance days in this period.",
    "estab_attendance.calendar_title": "Attendance calendar",
    "estab_attendance.expand_hint": "Click a teacher row to expand the day-by-day attendance calendar.",
    "estab_attendance.stats.workdays": "Workdays (excl. Sun)",
    "estab_attendance.stats.teachers": "Teachers",
    "estab_attendance.stats.present_total": "Total present days",
    "estab_attendance.stats.in_radius_total": "In-radius days",
    "estab_attendance.stats.radius_label": "{{m}} m radius",
    "estab_attendance.col.teacher": "Teacher",
    "estab_attendance.col.workdays": "Workdays",
    "estab_attendance.col.present": "Present",
    "estab_attendance.col.in_radius": "In radius",
    "estab_attendance.col.establishment": "Establishment",
    "estab_attendance.col.department": "Department",
    "estab_attendance.col.province": "Province",
    "estab_attendance.legend.in_radius": "Present (within radius)",
    "estab_attendance.legend.out_radius": "Present (outside radius)",
    "estab_attendance.legend.absent": "Absent",
    "estab_attendance.legend.sunday": "Sunday (excluded)",
    "estab_attendance.tooltip.in_radius": "{{date}} — Present within radius",
    "estab_attendance.tooltip.out_radius": "{{date}} — Present outside radius",
    "estab_attendance.tooltip.absent": "{{date}} — Absent",
    "estab_attendance.tooltip.sunday": "{{date}} — Sunday",
    "estab_attendance.tooltip.present": "{{date}} — Present",
    "estab_attendance.matrix_title": "Attendance calendar — all teachers",
    "estab_attendance.matrix_hint": "One row per teacher. Green tick = present within radius; orange tick = present outside radius.",
    "estab_attendance.matrix.col_name": "Name",
    "estab_attendance.matrix_legend_in": "Present within radius",
    "estab_attendance.matrix_legend_out": "Present outside radius",
    "estab_attendance.matrix_legend_empty": "Empty = absent or Sunday",
    "estab_attendance.all_establishments": "All establishments (optional)",
    "estab_attendance.all_establishments_short": "All establishments",
    "estab_attendance.establishment_optional_hint": "Leave empty to include all teachers for the date range and radius.",
    "estab_attendance.export_pdf": "Export PDF",
    "estab_attendance.export_excel": "Export Excel",
    "estab_attendance.export.error": "Export failed.",
    "estab_attendance.export.summary": "Summary",
    "estab_attendance.export.daily": "Daily",
    "estab_attendance.export.matrix": "Matrix",
    "estab_attendance.export.date": "Date",
    "estab_attendance.export.status": "Status",

    "area_attendance.page_kicker": "REGIONAL ATTENDANCE",
    "area_attendance.title": "Area attendance summary",
    "area_attendance.page_hint": "Compare assigned teachers with those who checked in for at least the minimum number of days, broken down by province and department.",
    "area_attendance.start_date": "Start date",
    "area_attendance.end_date": "End date",
    "area_attendance.days_present": "Min. days present",
    "area_attendance.days_hint": "Teachers must have checked in on at least this many days to count as checked.",
    "area_attendance.search": "Load summary",
    "area_attendance.error.dates": "Please select start and end dates.",
    "area_attendance.error.date_order": "Start date must be before end date.",
    "area_attendance.error.days": "Please enter a valid minimum days present (1 or more).",
    "area_attendance.error.load": "Failed to load the area attendance summary.",
    "area_attendance.no_results": "No data found for the selected criteria.",
    "area_attendance.query_hint": "{{start}} → {{end}} · min. {{days}} day(s) present",
    "area_attendance.stats.provinces": "Provinces",
    "area_attendance.stats.departments": "Departments",
    "area_attendance.stats.assigned": "Teachers assigned",
    "area_attendance.stats.checked": "Teachers checked",
    "area_attendance.province_departments": "{{n}} department(s)",
    "area_attendance.chip.assigned": "{{n}} assigned",
    "area_attendance.chip.checked": "{{n}} checked",
    "area_attendance.col.province": "Province",
    "area_attendance.col.department": "Department",
    "area_attendance.col.assigned": "Assigned",
    "area_attendance.col.checked": "Checked",
    "area_attendance.col.rate": "Check rate",
    "area_attendance.row.province_total": "Province total",
    "area_attendance.row.grand_total": "Grand total",
    "area_attendance.all_rows_title": "Full list — all provinces & departments",

    "teachers.table_range": "{{start}}–{{end}} of {{total}} teachers",
    "home.title": "Teachers list",
    "home.select_date": "Select date",
    "home.date_placeholder": "Select a date",
    "home.search": "Search",
    "home.table.attend_date": "Attendance date",
    "home.table.reg_number": "Teacher reg #",
    "home.table.teacher_name": "Teacher name",
    "home.table.gender": "Teacher gender",
    "home.table.status": "Teacher status",
    "home.table.degree": "Teacher degree",
    "home.table.est_coords": "Establishment coordinates",
    "home.table.att_coords": "Attendance coordinates",
    "home.table.distance": "Distance",
    "home.table.imei": "Phone IMEI",
    "home.modal.title": "History",
    "home.modal.cancel": "Cancel",
    "home.modal.attend_date": "Attendance date",
    "home.modal.est_coords": "Establishment coordinates",
    "home.modal.att_coords": "Attendance coordinates",
    "home.modal.distance": "Distance",
    "home.modal.imei": "Phone IMEI",
    "home.page_kicker": "ATTENDANCE",
    "home.page_hint": "Review check-ins for the selected date and open a teacher's attendance history.",
    "home.stats.records": "Check-ins",
    "home.stats.teachers": "Teachers",
    "home.stats.avg_distance": "Avg. distance",
    "home.stats.within_1km": "Within 1 km",
    "home.stats.this_month": "This month",
    "home.stats.this_week": "This week",
    "pagination.page_size": "Rows per page",
    "home.table.section_title": "Attendance records",
    "home.table_range": "{{start}}–{{end}} of {{total}} rows",
    "home.table_empty": "No check-ins to display.",
    "home.modal.subtitle": "Attendance history",
    "home.modal.kicker": "TEACHER",
    "home.modal.hint": "Punch times, GPS distance to establishment, and device IMEI.",
    "home.modal.stats.records": "Entries",
    "home.modal.stats.avg_distance": "Avg. distance",
    "home.modal.stats.span": "First → last",
    "home.modal.stats.far": "Far (> 1 km)",
    "home.modal.empty": "No attendance history for this teacher.",
    "home.modal.close": "Close",
    "home.date_filter_hint": "Selected date: {{date}}",
    "home.date_filter_all": "All dates (initial load)",
    "dashboard.stats.teachers": "Teachers",
    "dashboard.stats.recruiters_total": "Recruiters",
    "dashboard.stats.leave_pending": "Pending leave requests",
    "dashboard.stats.users": "Users",
    "dashboard.stats.missions_today": "Remaining licenses",
    "dashboard.stats.assignments_total": "Total assignments",
    "dashboard.chart.teachers": "Teacher statistics",
    "dashboard.chart.establishments": "Establishment statistics",
    "dashboard.chart.teacher_ratio": "Teacher ratio (Day / Cumulative)",
    "dashboard.chart.establishment_ratio": "Establishment ratio (Day / Cumulative)",
    "dashboard.filters.trend_title": "Trend period",
    "dashboard.filters.start_date": "From",
    "dashboard.filters.end_date": "To",
    "dashboard.filters.regional_title": "Regional snapshot (date & radius)",
    "dashboard.filters.snapshot_date": "Snapshot date",
    "dashboard.filters.radius_km": "Radius (km)",
    "dashboard.filters.apply": "Apply",
    "dashboard.filters.refresh_all": "Refresh all",
    "dashboard.filters.update_trends": "Trends",
    "dashboard.filters.update_regional": "Regional",
    "dashboard.filters.radius_hint": "Entered as km — converted to meters for the API.",
    "dashboard.filters.panel_title": "Reporting filters",
    "dashboard.filters.panel_hint": "Pick a trend range for charts and a snapshot date with radius for regional metrics.",
    "dashboard.filters.panel_hint_short": "Trend dates feed the top charts; regional date + radius feed the map, two regional charts, and two attendance KPI cards.",
    "dashboard.filters.tooltip_trends": "Reloads Dashboard/stats for the From–To range: updates the first two KPI cards, daily activity, and participation charts.",
    "dashboard.filters.tooltip_regional": "Reloads reports/statistical for snapshot date & radius: updates the map, two regional charts, and checked-in / within-radius KPIs.",
    "dashboard.filters.tooltip_refresh_all": "Runs trend, regional, recruiter, and leave-list requests so KPIs, charts, and previews match your filters.",
    "dashboard.filters.radius_m": "Distance (meters)",
    "dashboard.filters.radius_hint_m": "Radius in meters, sent as-is to the API.",
    "dashboard.chart.daily_activity": "Daily reporting activity",
    "dashboard.chart.daily_activity_hint": "Teachers and establishments reporting each day in the selected range.",
    "dashboard.chart.attendance_percentage": "Attendance percentage",
    "dashboard.chart.attendance_percentage_hint": "Daily percentage of people who checked in and did not check in.",
    "dashboard.chart.checked_in_pct": "Checked in (%)",
    "dashboard.chart.not_checked_in_pct": "Not checked in (%)",
    "dashboard.chart.participation_pct": "Participation rate (% of roster)",
    "dashboard.chart.participation_teachers_title": "Teacher participation (% of roster)",
    "dashboard.chart.participation_teachers_hint": "Daily teacher reporting as a share of the roster.",
    "dashboard.chart.participation_establishment_title": "Establishment participation (% of roster)",
    "dashboard.chart.participation_establishment_hint": "Daily establishment reporting as a share of the roster.",
    "dashboard.chart.teachers_daily": "Teachers (daily)",
    "dashboard.chart.establishments_daily": "Establishments (daily)",
    "dashboard.chart.reported": "Reported",
    "dashboard.chart.within_radius": "Within radius",
    "dashboard.regional.provinces": "By province",
    "dashboard.regional.departments": "By department",
    "dashboard.regional.establishments": "By establishment",
    "dashboard.stats.reported_establishments": "Reported (establishments)",
    "dashboard.stats.within_radius_total": "Within radius (total)",
    "dashboard.stats.teachers_active": "Licensed",
    "dashboard.stats.licensed_teachers": "Licensed",
    "dashboard.stats.remaining_licenses": "Remaining licenses",
    "dashboard.stats.registered_teachers": "Registered personnel",
    "dashboard.stats.max_licensed_teachers": "Max licensed personnel",
    "dashboard.stats.people_checked_in": "People checked in",
    "dashboard.stats.licensed_capacity": "Licensed capacity",
    "dashboard.stats.licensed_capacity_total": "Max licensed personnel",
    "dashboard.stats.slots_remaining": "Remaining licenses",
    "dashboard.filters.apply_trends": "Apply range",
    "dashboard.filters.trend_range_hint": "Daily charts use this range after you click Apply.",
    "dashboard.filters.apply_regional": "Apply snapshot",
    "dashboard.filters.radius_quick_label": "Quick radius",
    "dashboard.filters.radius_preset_500m": "500 m",
    "dashboard.filters.radius_preset_5km": "5 km",
    "dashboard.filters.radius_preset_50km": "50 km",
    "dashboard.filters.radius_preset_500km": "500 km",
    "dashboard.chart.quota_title": "Personnel licenses",
    "dashboard.chart.quota_summary_line": "Licensed: {{licensed}} / {{max}} · Remaining licenses: {{remaining}} · Registered: {{registered}}",
    "dashboard.chart.quota_insight_title": "Numbers at a glance",
    "dashboard.chart.quota_insight_subtitle": "How many license slots are in use right now.",
    "dashboard.chart.license_fill_label": "License utilization",
    "dashboard.chart.quota_licensed": "Licensed",
    "dashboard.chart.quota_remaining": "Remaining licenses",
    "dashboard.chart.period_toolbar_title": "Chart time window",
    "dashboard.chart.period_toolbar_hint": "Pick a preset to reload daily activity and participation charts for that span (same as From–To above).",
    "dashboard.chart.range_1m": "1 mo",
    "dashboard.chart.range_3m": "3 mo",
    "dashboard.chart.range_6m": "6 mo",
    "dashboard.chart.range_1y": "1 yr",
    "dashboard.chart.range_presets_aria": "Presets: 1 month to 1 year",

    "dashboard.recruiters.preview_title": "Recruiters",
    "dashboard.recruiters.preview_hint": "Quick view of your directory. Manage phones and linked teachers on the full page.",
    "dashboard.recruiters.view_all": "Open recruiters",
    "dashboard.recruiters.none": "No recruiters yet — add one from the recruiters page.",
    "dashboard.recruiters.more_count": "+{n} more on the recruiters page.",
    "dashboard.recruiters.count_subtitle": "{n} in your directory",
    "dashboard.recruiters.open_team": "View teachers enrolled by this recruiter",
    "dashboard.leaves.preview_title": "Leave requests",
    "dashboard.leaves.preview_hint": "Pending items first. Change status below or open the full page.",
    "dashboard.leaves.view_all": "Open leave requests",
    "dashboard.leaves.none": "No leave requests loaded.",
    "dashboard.leaves.more_count": "+{n} more on the leave requests page.",
    "auth.sign_in.title": "Welcome back",
    "auth.sign_in.description": "Enter your email and password to sign in",
    "auth.sign_in.email_label": "Email",
    "auth.sign_in.email_placeholder": "Enter your email",
    "auth.sign_in.password_label": "Password",
    "auth.sign_in.password_placeholder": "Password",
    "auth.sign_in.submit": "Sign In",
    "auth.sign_in.success_title": "Signed in",
    "auth.sign_in.error_title": "Invalid email or password",

    "change_password.title": "Change password",
    "change_password.current_password": "Current password",
    "change_password.new_password": "Confirm password",
    "change_password.save": "SAVE",
    "change_password.success_title": "Password changed",
    "change_password.success_text": "The password has been changed successfully.",
    "change_password.error_title": "Error",
    "change_password.error_text": "An error occurred while changing the password.",

    "users.add_title": "Add user",
    "users.edit_title": "Edit user",
    "users.edit_kicker": "EDIT USER",
    "users.edit_hint": "Update profile and assignment area.",
    "users.saving": "Saving...",
    "users.list_title": "User list",
    "users.page_kicker": "USERS",
    "users.page_hint": "Create accounts and manage access by role and area.",
    "users.stats.total": "Total",
    "users.stats.admin": "Administrators",
    "users.stats.member": "Members / agents",
    "users.stats.observer": "Observers",
    "users.stats.other": "Other roles",
    "users.table_range": "{{start}}–{{end}} of {{total}} users",
    "users.role_other": "Other",
    "users.table_section_title": "User directory",
    "users.form_show": "Show form",
    "users.form_hide": "Hide form",
    "users.form_add": "Add user",
    "users.form_section_title": "New user",
    "users.table_empty": "No users to display.",
    "users.page_title": "User management",
    "users.first_name": "First name",
    "users.last_name": "Last name",
    "users.title": "Title",
    "users.title_placeholder": "E.g. Principal, Inspector",
    "users.title_max": "Title cannot exceed 100 characters",
    "users.email": "Email",
    "users.password": "Password",
    "users.confirm_password": "Confirm password",
    "users.phone": "Phone",
    "users.whatsapp": "WhatsApp",
    "users.gender_label": "Select gender",
    "users.gender_placeholder": "Select gender",
    "users.role_label": "Select a role",
    "users.role_placeholder": "Select a role",
    "users.role_admin": "Administrator",
    "users.role_user": "Data entry agent",
    "users.role_auth": "Other user",
    "users.role_observator": "Observer",
    "users.province": "Province",
    "users.province_placeholder": "Select province",
    "users.department": "Department",
    "users.department_placeholder": "Select department",
    "users.select_all_geography": "Select all provinces and departments",
    "users.select_all_departments": "Select all departments",
    "users.save": "SAVE",
    "users.cancel": "Cancel",
    "users.table.name": "Name",
    "users.table.title": "Title",
    "users.table.email": "Email",
    "users.table.gender": "Gender",
    "users.table.role": "Role",
    "users.table.phone": "Phone",
    "users.table.whatsapp": "WhatsApp",
    "users.table.provinces": "Provinces",
    "users.table.department": "Department",
    "users.table.actions": "Actions",
    "users.create_success_title": "User created",
    "users.create_success_text": "The user has been created successfully.",
    "users.create_error_title": "Error",
    "users.create_error_text": "An error occurred while creating the user.",
    "users.update_success_title": "User updated",
    "users.update_success_text": "The user has been updated successfully.",
    "users.update_error_title": "Error",
    "users.update_error_text": "An error occurred while updating the user.",
    "users.delete_confirm_title": "Are you sure?",
    "users.delete_confirm_text": "This action is irreversible!",
    "users.delete_confirm_ok": "Yes, delete it!",
    "users.delete_confirm_cancel": "Cancel",
    "users.delete_success_title": "Deleted!",
    "users.delete_success_text": "The user has been deleted.",
    "users.delete_error_title": "Error",
    "users.delete_error_text": "An error occurred while deleting the user.",

    "assignments.title": "Teacher assignments",
    "assignments.summary_title": "Assignments summary",
    "assignments.page_kicker": "ASSIGNMENTS",
    "assignments.page_hint": "Link teachers to establishments and review history.",
    "assignments.stats.total": "Records",
    "assignments.stats.teachers": "Distinct teachers",
    "assignments.stats.establishments": "Establishments",
    "assignments.stats.provinces": "Provinces",
    "assignments.stats.this_month": "This month",
    "assignments.stats.today": "Today",
    "assignments.stats.this_week": "This week",
    "assignments.stats.page_hint": "Filtered results",
    "assignments.server_filters": "Search & filters",
    "assignments.server_filters_hint": "Filters run on the server. Dashboard cards use top-level Stats from the API.",
    "assignments.search_placeholder": "Search reg number, name, phone, establishment…",
    "assignments.status_filter_placeholder": "e.g. Active",
    "assignments.filter_all_status": "All statuses",
    "assignments.teacher_filter_count": "{{count}} matching person(s)",
    "assignments.filters_active_count": "{{count}} active",
    "assignments.viewing_filtered": "{{total}} assignment(s) matching filters",
    "assignments.form_section_title": "New assignment",
    "assignments.form_show": "Show form",
    "assignments.form_hide": "Hide form",
    "assignments.form_add": "Add assignment",
    "assignments.table_empty": "No assignments to display.",
    "assignments.table_range": "{{start}}–{{end}} of {{total}} rows",
    "assignments.province": "Province",
    "assignments.province_placeholder": "Select province",
    "assignments.department": "Department",
    "assignments.department_placeholder": "Select department",
    "assignments.subprefecture": "Sub-prefecture",
    "assignments.subprefecture_placeholder": "Select sub-prefecture",
    "assignments.establishment": "Establishment",
    "assignments.establishment_placeholder": "Select establishment",
    "assignments.teachers": "Teachers to be assigned",
    "assignments.teachers_placeholder": "Select teacher",
    "assignments.teacher_filter.all": "All",
    "assignments.teacher_filter.assigned": "Assigned",
    "assignments.teacher_filter.unassigned": "Unassigned",
    "assignments.date": "Assignment date",
    "assignments.save": "SAVE",
    "assignments.table.teacher_name": "Teacher name",
    "assignments.table.teacher_degree": "Teacher degree",
    "assignments.table.subprefecture": "Sub-prefecture",
    "assignments.table.department": "Department",
    "assignments.table.province": "Province",
    "assignments.table.date": "Assignment date",
    "assignments.table.establishment": "Establishment",
    "assignments.table.actions": "Actions",
    "assignments.create_success_title": "Assignment created",
    "assignments.create_success_text": "The assignment has been created successfully.",
    "assignments.create_error_title": "Error",
    "assignments.create_error_text": "An error occurred while creating the assignment.",
    "assignments.reassign_confirm_title": "Teacher already assigned",
    "assignments.reassign_confirm_text": "{{teacher}} is currently assigned to {{establishment}}. Assign them to the new establishment instead?",
    "assignments.reassign_confirm": "Yes, reassign",
    "assignments.reassign_cancel": "Cancel",
    "assignments.teacher_fallback": "This teacher",
    "assignments.establishment_fallback": "another establishment",

    "statistics.title": "Statistics",
    "statistics.export_pdf": "Export as PDF",
    "statistics.export_excel": "Export Excel",
    "statistics.date_label": "Select date",
    "statistics.header_hint": "Search refreshes all charts and tables. Radius is entered in meters and sent as-is to the API.",
    "statistics.header_hint_tables_first": "Tables show detailed figures; charts below summarize the same data.",
    "statistics.distance_label": "Search radius (meters)",
    "statistics.distance_meters": "Distance (meters)",
    "statistics.radius_meters_hint": "Radius in meters, sent as-is to the API.",
    "statistics.search": "Search",
    "statistics.table.name": "Name",
    "statistics.table.reported": "Number of teachers reported",
    "statistics.table.reported_radius": "within a specified radius",
    "statistics.table.total": "Number of teachers total",
    "statistics.table.total_row": "Total",
    "statistics.section.establishment": "Establishment",
    "statistics.section.province": "Province",
    "statistics.section.department": "Department",
    "statistics.chart.compare_hint": "Reported vs within radius (same scale for comparison).",
    "statistics.visual_overview": "Charts",
    "statistics.chart.section_intro": "Horizontal bars compare reported counts with within-radius counts — same fields as the tables above.",
    "statistics.chart.bar_compare_hint": "Reported vs within radius — same scale for both series.",
    "statistics.chart.type_vertical": "Grouped vertical bars — reported vs within radius (different from the dashboard’s horizontal bars).",
    "statistics.chart.type_doughnut": "Share of reported teachers by province — distinct from dashboard regional bars.",
    "statistics.chart.type_radar": "Radar chart comparing both metrics across departments.",
    "statistics.pdf.title": "Teachers — statistical report",
    "statistics.pdf.page": "Page",
    "statistics.pdf.table_block": "Table",
    "statistics.pdf.chart_block": "Chart",

    "teacher_history.title": "History",

    "teacher_detail.title": "Teacher profile",
    "teacher_detail.open_profile": "View profile",
    "teacher_detail.back": "Back",
    "teacher_detail.view_history": "History",
    "teacher_detail.view_map": "View on map",
    "teacher_detail.refresh": "Refresh",
    "teacher_detail.not_found": "Teacher not found.",
    "teacher_detail.missing_id": "Teacher id or matricule is required.",
    "teacher_detail.load_error": "Unable to load teacher profile.",
    "teacher_detail.licensed": "Licensed",
    "teacher_detail.unlicensed": "Unlicensed",
    "teacher_detail.pending_activation": "Pending activation",
    "teacher_detail.staff_license_note": "License activation applies to teachers only. Manage licenses from Teacher Licenses.",
    "teacher_detail.open_licenses": "Open Teacher Licenses to activate",
    "teacher_detail.allocated": "Assigned",
    "teacher_detail.has_attendance": "Has attendance",
    "teacher_detail.score": "Score",
    "teacher_detail.documents": "Documents",
    "teacher_detail.documents_count": "document(s)",
    "teacher_detail.document": "Document",
    "teacher_detail.view_document": "View document",
    "teacher_detail.open_document": "Open original",
    "teacher_detail.download_document": "Download",
    "teacher_detail.document_preview_unavailable": "Preview unavailable",
    "teacher_detail.close_document": "Close",
    "teacher_detail.kpi.total": "Total attendance",
    "teacher_detail.kpi.this_month": "This month",
    "teacher_detail.kpi.this_week": "This week",
    "teacher_detail.kpi.last_seen": "Last seen",
    "teacher_detail.kpi.within_radius": "Within radius",
    "teacher_detail.section.profile": "Profile",
    "teacher_detail.section.assignment": "Current assignment",
    "teacher_detail.section.ranking": "Ranking",
    "teacher_detail.first_attendance": "First attendance",
    "teacher_detail.avg_per_month": "Avg. per month",
    "teacher_detail.unique_establishments": "Establishments",
    "teacher_detail.establishment": "Establishment",
    "teacher_detail.estab_type": "Type",
    "teacher_detail.assigned_date": "Assigned",
    "teacher_detail.location": "Location",
    "teacher_detail.not_assigned": "Not currently assigned.",
    "teacher_detail.rank.overall": "Overall",
    "teacher_detail.rank.province": "Province",
    "teacher_detail.rank.department": "Department",
    "teacher_detail.last_score": "Last score date",
    "teacher_detail.chart.monthly_title": "Monthly attendance trend",
    "teacher_detail.chart.monthly_desc": "Check-ins over the selected period",
    "teacher_detail.chart.day_title": "By day of week",
    "teacher_detail.chart.day_desc": "Distribution across weekdays",
    "teacher_detail.chart.estab_title": "By establishment",
    "teacher_detail.chart.estab_desc": "Share of check-ins per school",
    "teacher_detail.chart.monthly": "Attendance",
    "teacher_detail.chart.by_day": "By day",
    "teacher_detail.chart.by_establishment": "By establishment",
    "teacher_detail.recent_attendance": "Recent attendance",
    "teacher_detail.records": "records",
    "teacher_detail.day": "Day",
    "teacher_detail.radius_status": "Radius",
    "teacher_detail.no_attendance": "No attendance records.",
    "teacher_detail.export": "Export",
    "teacher_detail.export_pdf": "PDF (page)",
    "teacher_detail.export_csv": "CSV (data)",
    "teacher_detail.export_excel": "Excel (data)",
    "teacher_detail.export_error": "Export failed",
    "teacher_detail.export_no_data": "No data to export.",
    "teacher_detail.export_pdf_title": "Teacher profile",
    "teacher_detail.export_sheet_overview": "Overview",
    "teacher_detail.export_sheet_attendance": "Attendance",
    "teacher_detail.export_sheet_monthly": "Monthly",
    "teacher_detail.export_sheet_by_day": "By day",
    "teacher_detail.export_sheet_by_estab": "By establishment",
    "teacher_detail.export_section_profile": "Profile",
    "teacher_detail.export_section_summary": "Summary",
    "teacher_detail.export_section_assignment": "Assignment",
    "teacher_detail.export_section_ranking": "Ranking",
    "teacher_detail.export_assignment_status": "Assignment status",
    "teacher_detail.export_latitude": "Latitude",
    "teacher_detail.export_longitude": "Longitude",
    "teacher_detail.export_period": "Period",
    "teacher_detail.export_count": "Count",
    "teacher_detail.export_no_data": "No data",
    "teacher_detail.export_page": "Page",
    "teacher_detail.export_days_since": "Days since last attendance",
    "teacher_detail.export_within_radius_count": "Check-ins within radius",
    "teacher_detail.export_outside_radius_count": "Check-ins outside radius",
    "teacher_detail.export_field": "Field",
    "teacher_detail.export_value": "Value",
    "teacher_detail.export_csv_error": "Could not create the CSV file.",
    "teacher_detail.export_excel_error": "Could not create the Excel file.",
    "teacher_detail.export_pdf_error": "Could not create the PDF file.",
    "teacher_detail.export_pdf_fallback_title": "PDF created",
    "teacher_detail.export_pdf_fallback_text": "A simplified PDF was generated because visual capture was blocked in this browser.",

    "dashboard.missions_overview": "Missions overview",
    "dashboard.this_month": "this month",
    "dashboard.projects.title": "teachers",
    "dashboard.projects.done_this_month": "done this month",
    "dashboard.projects.columns.companies": "COMPANIES",
    "dashboard.projects.columns.members": "MEMBERS",
    "dashboard.projects.columns.budget": "BUDGET",
    "dashboard.projects.columns.completion": "COMPLETION",
    "dashboard.projects.undefined": "Not defined",

    "validation.email_invalid": "Invalid email",
    "validation.email_required": "Email is required",
    "validation.password_required": "Password is required",
    "validation.password_min": "Password must be at least 8 characters",
    "validation.password_lowercase": "Password must contain at least one lowercase letter ('a'-'z')",
    "validation.password_uppercase": "Password must contain at least one uppercase letter ('A'-'Z')",
    "validation.password_special": "Password must contain at least one non-alphanumeric character",
    "validation.password_match": "Passwords must match",
    "validation.confirm_password_required": "Password confirmation is required",
    "validation.first_name_required": "First name is required",
    "validation.last_name_required": "Last name is required",
    "validation.gender_required": "Gender is required",
    "validation.phone_required": "Phone number is required",
    "validation.role_required": "Role is required",
    "validation.current_password_required": "Current password is required",
    "validation.new_password_required": "New password is required",
    "validation.province_required": "Province is required",
    "validation.department_required": "Department is required",
    "validation.subprefecture_required": "Sub-prefecture is required",
    "validation.establishment_required": "Establishment is required",
    "validation.teachers_required": "Teachers to be assigned is required",
    "validation.assignment_date_required": "Assignment date is required",

    "assistant.title": "eVerifPro Assistant",
    "assistant.subtitle": "Secure · on-premise",
    "assistant.open": "Open assistant",
    "assistant.open_tooltip": "eVerifPro Assistant (⌘K)",
    "assistant.expand": "Full screen",
    "assistant.collapse": "Collapse",
    "assistant.page_title": "eVerifPro Assistant",
    "assistant.page_subtitle": "Full screen — same conversation as the floating panel. Collapse to return.",
    "assistant.placeholder": "Ask a question…",
    "assistant.hint": "Enter send · Shift+Enter new line · ⌘K toggle",
    "assistant.hint_page": "Enter send · Shift+Enter new line · Collapse to return to the floating panel",
    "assistant.clear": "Clear conversation",
    "assistant.refresh": "Refresh alerts",
    "assistant.action.open": "Open",
    "assistant.action.view_teachers": "View teachers",
    "assistant.action.view_recruiters": "View recruiters",
    "assistant.action.view_assignments": "View assignments",
    "assistant.action.view_establishments": "View establishments",
    "assistant.action.view_dashboard": "Dashboard",
    "assistant.action.view_stats": "Statistics",
    "assistant.action.review_leaves": "Review leave",
    "assistant.action.leave_guide": "Leave guide",
    "assistant.action.next_step": "Next step",
    "assistant.action.open_page": "Open page",
    "assistant.action.help_page": "Help this page",
    "assistant.prompts_label": "I can help you with",
    "assistant.prompts_commands_label": "Quick actions",
    "assistant.generating_summary": "Still generating your answer…",
    "assistant.writing_answer": "Writing your answer…",
    "assistant.llm_online": "Ready to help",
    "assistant.llm_offline": "Offline",
    "assistant.llm_checking": "Connecting…",
    "assistant.llm_online_hybrid": "Ready to help",
    "assistant.llm_smart_routing": "Enhanced conversation mode",
    "assistant.llm_writing": "One moment…",
    "assistant.llm_streaming": "One moment…",
    "assistant.ai_routing_on": "Smarter conversation understanding",
    "assistant.ai_routing_off": "Fast responses (standard mode)",
    "assistant.gemini_online": "Gemini cloud · ready",
    "assistant.gemini_on": "Gemini cloud AI (fast). Data sent to Google.",
    "assistant.gemini_off": "Local Ollama AI (private, slower on this server)",
    "assistant.gemini_need_smart": "Turn on Smart AI first to use Gemini",
    "assistant.mode_dialog_title": "Assistant response mode",
    "assistant.mode_dialog_hint": "Choose how the assistant answers. You can change this anytime.",
    "assistant.mode_dialog_open": "Change response mode",
    "assistant.mode_dialog_done": "Done",
    "assistant.mode_rules_title": "Standard",
    "assistant.mode_rules_desc": "Instant answers from portal rules and live data. Recommended for daily use.",
    "assistant.mode_rules_subtitle": "Rules & live data · instant",
    "assistant.mode_local_title": "Local AI",
    "assistant.mode_local_desc": "On-premise Ollama on your server. Private — no data leaves your network. May be slower.",
    "assistant.mode_local_subtitle": "Local AI · on-premise",
    "assistant.mode_local_offline": " · Ollama offline",
    "assistant.mode_gemini_title": "Cloud AI (Gemini)",
    "assistant.mode_gemini_desc": "Google Gemini — fast responses. Sanitized text is sent to Google's API.",
    "assistant.mode_gemini_offline": " · currently unavailable",
    "assistant.mode_gemini_unconfigured": " · not configured on server",
    "assistant.tour_open": "Quick tour",
    "assistant.tour_prompt": "Take a quick tour",
    "assistant.insight.pending_leaves": "{{count}} pending leave request(s)",
    "assistant.insight.teacher_roster": "{{count}} registered teacher(s)",
    "assistant.insight.recruiters": "{{count}} active recruiter(s)",
    "assistant.insight.assignments": "{{count}} assignment(s) on record",
    "assistant.insight.license_exhausted": "No license slots remaining — {{count}} teacher(s) awaiting activation",
    "assistant.action.view_teacher_licenses": "Open teacher licenses",
  },
};

const getStoredLanguage = () => {
  const stored = localStorage.getItem("appLanguage");
  if (stored === "fr" || stored === "en") return stored;
  return null;
};

export const detectInitialLanguage = () => getStoredLanguage() || "fr";

export const useTranslate = () => {
  const [controller, dispatch] = useSoftUIController();
  const storedLanguage = getStoredLanguage();
  const language = storedLanguage || controller.language || "fr";

  useEffect(() => {
    if (storedLanguage && storedLanguage !== controller.language) {
      setLanguage(dispatch, storedLanguage);
    }
  }, [storedLanguage, controller.language, dispatch]);

  const t = useMemo(
    () => (key, fallback = "") =>
      translations[language]?.[key] ?? fallback ?? key,
    [language]
  );

  const setLang = (value) => {
    const next = value === "fr" ? "fr" : "en";
    localStorage.setItem("appLanguage", next);
    setLanguage(dispatch, next);
  };

  return { t, language, setLanguage: setLang };
};
